import { Button, Divider } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link as RouterLink } from 'react-router-dom';

import CarImg from '../images/hero/HeroRightImages/carImg.png';
import EngineIcon from '../images/hero/HeroRightImages/engineIcon.png';
import CarLoanIcon from '../images/hero/HeroRightImages/carLoanIcon.png';
import CarPaintIcon from '../images/hero/HeroRightImages/carPaintIcon.png';
import FairPriceIcon from '../images/hero/HeroRightImages/fairPriceIcon.png';
import ScannerIcon from '../images/hero/HeroRightImages/scannerIcon.png';
import WatchImg from '../images/hero/HeroRightImages/watchImg.png';

import AiDrivenLogo from '../../assets/gradeIcons/aiDrivenEngine.png';
import OBDScanner from '../../assets/gradeIcons/OBDScanner.png';
import UnbiasedCustomer from '../../assets/gradeIcons/unbiasedCustomer.png';

import one from '../images/queryComponent/oneICon.png';
import two from '../images/queryComponent/twoIcon.png';
import three from '../images/queryComponent/threeIcon.png';

import roadsideAssist from '../numberIcons/roadsideAssist.png';
import cities from '../numberIcons/cities.png';
import customerSupport from '../numberIcons/customerSupport.png';
import kilometer from '../numberIcons/kmDriven.png';
import warranty from '../numberIcons/warranty.png';
import inspected from '../numberIcons/inspected.png';
import recomended from '../../assets/images/recommended.png';

import Indonesia from '../../assets/icons/cityIcons/indonesia.png';

export const IndonesiaContent = {
  headerPage: {
    menuItems: (
      <>
        <li>
          <a aria-label="" href="/id#inspection-plans">
            Rencana Inspeksi
          </a>
        </li>
        <li>
          <a aria-label="" href="/id#how-it-works">
            Cara Kerjanya
          </a>
        </li>
        <li>
          <a aria-label="" href="/id#why-wisedrive">
            Mengapa Wisedrive
          </a>
        </li>
        <li>
          <a aria-label="" href="/id#contact-us">
            Hubungi Kami
          </a>
        </li>
      </>
    ),
    languages: [
      {
        id: 'en',
        label: 'EN',
      },
      {
        id: 'id',
        label: 'ID',
      },
    ],
  },
  heroPage: {
    headLine: (
      <div className="hero-headline">
        <img loading="lazy" src={CarImg} width="30px" alt="Gambar Mobil" />
        <p>Membeli Mobil Bekas?</p>
      </div>
    ),
    header: (
      <h2>
        Periksa Mobil Bekas Dulu,
        <span style={{ color: 'red' }}>
          <br /> Agar Tak Menyesal Kemudian!
        </span>
      </h2>
    ),
    subPoints: [
      'Hindari Biaya Perbaikan Mahal',
      'Dapatkan Kondisi Mobil yang Sesungguhnya',
      'Pembelian Tanpa Risiko',
      'Pemeriksaan oleh Ahli Terpercaya',
    ],
    btnText: 'Pesan Inspeksi',
    cardTitles: [
      {
        color: '#003cc5',
        content: (
          <>
            <h4>200+</h4>
            <p style={{ color: 'white' }}>Poin pemeriksaan tercakup</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={EngineIcon} alt="" />
            <p>
              Mesin & <br /> Transmisi
            </p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarPaintIcon} alt="" />
            <p>Pemeriksaan Penyok & Cat</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={ScannerIcon} alt="" />
            <p>Pemindaian OBD2 Lanjutan</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarLoanIcon} alt="" />
            <p>Pemeriksaan Keuangan dan RTO</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={FairPriceIcon} alt="" />
            <p>Jaminan Harga Wajar</p>
          </>
        ),
      },
    ],
    rightFooter: (
      <>
        <p className="hero-right-footer-p">
          Inspeksi ahli kami telah menghemat pelanggan sebesar{' '}
          <strong>485 Billion IDR </strong>
          dengan mencegah kesalahan mahal pada mobil yang memiliki kerusakan
          mesin tersembunyi dan perbaikan setelah pembelian.
        </p>
        <p className="hero-right-footer-p">
          <strong style={{ color: 'red' }}>
            Jangan ambil risiko dengan uang hasil jerih payah Anda – periksa
            mobil bekas Anda hari ini!
          </strong>
        </p>
      </>
    ),
  },
  planDetails: {
    header: (
      <div className="inspection-header-container">
        <div>
          <h2 className="inspection-header">
            Kami telah mencakup semuanya untuk melindungi mobil Anda.
          </h2>
          <h2 className="inspection-header-red">200+ Poin Pemeriksaan.</h2>
        </div>
        <div>
          <img
            loading="lazy"
            src={recomended}
            alt=""
            className="logo-web"
          ></img>
          <div className="mbl-View-only">
            <img
              loading="lazy"
              src={recomended}
              alt=""
              className="recomended-img"
            ></img>
            <RouterLink
              style={{
                color: '#003cc5',
                fontSize: '18px',
                border: '1px solid',
                borderColor: '#003cc5',
                padding: '5px',
                borderRadius: '6px',
              }}
              target="_blank"
              to={'/sample-report'}
            >
              <p
                style={{
                  color: 'rgb(0, 60, 197)',
                  fontFamily: 'matterThin',
                  fontSize: '12px',
                  paddingTop: '0px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  paddingLeft: '0px !important',
                }}
              >
                Laporan Contoh
                <OpenInNewIcon fontSize="small" />
              </p>
            </RouterLink>
          </div>
        </div>
      </div>
    ),
    currency: 'IDR',
    noteTaxes: 'Termasuk semua pajak',
    infoNote:
      'Laporan inspeksi akan dikirim melalui WhatsApp ke nomor ponsel yang terdaftar saat pemesanan.',
    inspectionCardsArray: [
      {
        header: 'Pemeriksaan Fisik / Manual',
        checkPoints: '135',
        inspectionItems: [
          'Pemeriksaan Mesin & Transmisi',
          'Pemeriksaan Komponen Elektrik',
          'Pemeriksaan Komponen Mekanik',
          'Pemeriksaan Interior & Eksterior',
        ],
        additionalBenifits: {
          header: 'Manfaat Tambahan',
          data: [
            'Pemeriksaan kendaraan bekas banjir, Pemeriksaan perbaikan mesin besar',
            'Pemeriksaan fungsi baterai, Pemeriksaan manipulasi odometer',
            'Pemeriksaan sistem rem, Pemeriksaan sistem bahan bakar',
          ],
        },
      },
      {
        header: 'Verifikasi Samsat & Polisi',
        checkPoints: '29',
        inspectionItems: [
          'Pemeriksaan Pinjaman dan Asuransi',
          'Pemeriksaan Denda Lalu Lintas & Daftar Hitam',
          'Pemeriksaan Masa Berlaku STNK dan KIR',
          'Pemeriksaan Informasi Pemilik & Kendaraan',
        ],
        additionalBenifits: {
          header: 'Manfaat Tambahan',
          data: [
            'Pemeriksaan Surat Pelunasan Kredit, Pemeriksaan Masa Berlaku Asuransi',
            'Pemeriksaan Status Daftar Hitam',
            'Verifikasi data penipuan dan dokumen STNK dengan database Samsat',
          ],
        },
      },
      {
        header: 'Tes Pemindai OBD2 Lanjutan',
        checkPoints: '76',
        inspectionItems: [
          'Modul Kontrol Mesin (ECM)',
          'Modul Kontrol Transmisi',
          'Modul Kontrol Bodi (BCM)',
          'Pemeriksaan & Analisis Kode Kesalahan',
        ],
        additionalBenifits: {
          header: 'Manfaat Tambahan',
          data: [
            'Analisis kemungkinan kerusakan mesin, Analisis kemungkinan kerusakan transmisi',
            'Pemeriksaan kestabilan kendaraan pada kecepatan tinggi menggunakan pemindai OBD-2 canggih',
            'Pemeriksaan pencegahan perbaikan mahal',
          ],
        },
      },
      {
        header: 'Dukungan Teknis Tambahan',
        checkPoints: '76',
        inspectionItems: [
          'Estimasi Harga Wajar',
          'Estimasi Biaya Perbaikan',
          'Saran dari Mekanik Ahli',
          'Garansi Perpanjangan hingga 2 tahun',
        ],
      },
    ],
    partPaymentAmount: 500,
    partialBtnText: 'Bayar IDR 500 Uang Muka',
    btnBookInspection: 'Pesan Inspeksi',
    sampleBtnText: 'Laporan Contoh',
    steps: [
      'Daftar dengan No. HP',
      'Masukkan Detail Mobil',
      'Pilih Kota untuk Inspeksi',
      'Verifikasi Detail Pembayaran',
    ],
    formHeader: (
      <>
        Membuka Standar
        <br /> Inspeksi Mobil
      </>
    ),
    errorName: 'Harap masukkan nama',
    labelName: 'Nama',
    errorMobile: 'Harap masukkan nomor',
    labelMobile: 'Nomor HP',
    otpSuccessMsg: 'OTP telah dikirim melalui SMS ke nomor HP Anda',
    resendOtpLbl: 'Kirim Ulang OTP',
    sendOtpLbl: 'Kirim OTP',
    entrrOtpLbl: 'Masukkan OTP',
    entrrOtpErrorLbl: 'Harap masukkan OTP yang valid',
    verifyOtpBth: 'Verifikasi OTP',
    otpNote: (
      <>
        Dengan menghubungi kami, Anda setuju dengan{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/id/inspection-terms-and-conditions'}
        >
          <strong>Syarat Layanan</strong> dan <strong>Kebijakan Privasi</strong>
        </RouterLink>
      </>
    ),
    registerHeader: 'Masukkan Nomor Registrasi Mobil',
    searchBtn: 'CARI',
    carMakeLbl: 'Merek',
    carModelLbl: 'Model',
    carMfYearLbl: 'Tahun Pembuatan',
    carTypeLbl: 'Jenis',
    carColorLbl: 'Warna',
    confirmBtn: 'Ya, Konfirmasi Mobil',
    skipBtn: 'Lewati ke Pembayaran',
    cityIconArray: [
      {
        name: 'Greater Jakarta',
        icon: Indonesia,
      },
      {
        name: 'Bandung',
        icon: Indonesia,
      },
      {
        name: 'Surabaya',
        icon: Indonesia,
      },
      {
        name: 'Medan',
        icon: Indonesia,
      },
      {
        name: 'Semarang',
        icon: Indonesia,
      },
    ],
    selectTimeLbl: 'Pilih Waktu',
    selectDateLbl: 'Pilih Tanggal',
    cityLbl: 'Kota',
    addressLbl: 'Masukkan Alamat Inspeksi',
    confirmInspectionBtn: 'Konfirmasi Inspeksi',
    payHeadr: 'Ringkasan',
    pkgAmtLbl: 'Jumlah Paket',
    inspCurrencyLbl: ' Inspeksi x IDR',
    totalAmtLbl: 'Total Jumlah',
    partialBtnNote: 'Sisa jumlah harus dibayar setelah inspeksi mobil selesai',
    fullBtnText: 'Bayar Penuh',
    fullBtnNote: (
      <>
        Dengan memilih pembayaran penuh, Anda setuju dengan{' '}
        <strong>Syarat Layanan</strong> dan <strong>Kebijakan Privasi</strong>
      </>
    ),
    termsTxt: (
      <>
        Dengan melanjutkan, saya memahami dan setuju dengan{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/id/inspection-terms-and-conditions'}
        >
          <strong>Syarat Layanan</strong> dan <strong>Kebijakan Privasi</strong>
        </RouterLink>
        dari PT Wisedrive Technologies Indonesia
      </>
    ),
    secureLbl: 'Pembayaran aman oleh',
    whatsappFooterTxt: (
      <>
        Sapa kami di{' '}
        <span
          style={{
            fontSize: '16px',
            fontFamily: 'matterBold',
          }}
        >
          WhatsApp di 87840125467{' '}
        </span>{' '}
        untuk pertanyaan dari pukul 9 pagi - 7 malam Senin - Sabtu.
      </>
    ),
    brandsCovered: 'Merek yang Dicakup',
    brandCoveredHeader: 'Merek yang Dicakup dalam setiap paket inspeksi',
    brandsCoveredNote:
      'Semua jenis mobil seperti hatchback, sedan, MUV, MPV, SUV dicakup dalam setiap merek',
    standardLbl: 'Standar',
    luxaryLbl: 'Mewah',
    brandsStandardArray: [
      'MARUTHI SUZUKI',
      'HYUNDAI',
      'HONDA',
      'KIA',
      'TOYOTA',
      'VOLKSWAGEN',
      'SKODA',
      'RENAULT',
      'NISSAN',
      'MAHINDRA',
      'TATA MOTORS',
      'FORD',
      'FIAT',
      'DATSUN',
      'MISTUBISHI',
      'Chery',
      'Isuzu',
      'Mazda',
      'Mitsubishi',
      'Perodua',
      'Proton',
      'Peugeot',
    ],
    brandsLuxuryArray: [
      'MERCHEDES BENZ',
      'BMW',
      'AUDI',
      'VOLVO',
      'FERRARI',
      'BUGATTI',
      'Range Rover',
      'Lexus ',
      'Mini Cooper',
    ],
    paymentFormFooter: (
      <>
        Dengan melanjutkan, saya memahami dan setuju dengan{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/id/inspection-terms-and-conditions'}
        >
          <strong>Syarat Layanan</strong> dan <strong>Kebijakan Privasi</strong>
        </RouterLink>
        dari PT Wisedrive Technologies Indonesia
      </>
    ),
  },
  flexiPay: {
    header: (
      <h2>
        Sesuaikan Garansi Mobil Anda dengan solusi
        <br /> <span style={{ color: '#ff7858' }}>‘Flexi-Pay’</span> kami ..
      </h2>
    ),
    cardContent: [
      {
        color: '#003cc5',
        content: (
          <>
            <div className="flexi-quarterly">
              <div className="flexi-card-header">
                <h6 style={{ color: 'black' }}>
                  Rencana Pembayaran <br />
                  Triwulanan
                </h6>
                <div className="flexi-card-headright">
                  <p>Mulai dari</p>

                  <span style={{ fontFamily: 'matter' }}>
                    IDR
                    <p
                      style={{
                        fontSize: '22px',
                        fontFamily: 'matterSemibold',
                      }}
                    >
                      1499
                    </p>
                  </span>
                </div>
              </div>
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    0-3 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">Pelanggan</p>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">Wisedrive</p>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Pembayaran</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    4-6 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Pembayaran</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    7-9 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Pembayaran</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    10-12 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Pembayaran</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <a aria-label="" href="/id#contact-us">
                  <Button
                    variant="contained"
                    sx={{
                      color: 'white',
                      fontSize: '18px',
                      fontFamily: 'matterMedium',
                      margin: '10px',
                      backgroundColor: '#e61f93',
                    }}
                  >
                    Hubungi Penjualan
                  </Button>
                </a>
              </div>
            </div>
          </>
        ),
      },
      {
        content: (
          <>
            <div>
              <div className="flexi-halfCard-wrap">
                <div className="flexi-halfyearly">
                  <div className="flexi-card-header">
                    <h6 style={{ color: 'black' }}>
                      Rencana Pembayaran <br />6 Bulan
                    </h6>
                    <div className="flexi-card-headright">
                      <p>Mulai dari</p>

                      <span style={{ fontFamily: 'matter' }}>
                        IDR
                        <p
                          style={{
                            fontSize: '22px',
                            fontFamily: 'matterSemibold',
                          }}
                        >
                          2999
                        </p>
                      </span>
                    </div>
                  </div>
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        0-6 <br /> Bulan
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Pelanggan</p>
                      <p className="card-percent-p">10%</p>
                      <p className="card-label-p">Co-Pay</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Wisedrive</p>
                      <p className="card-percent-p">90%</p>
                      <p className="card-label-p">Pembayaran</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        7-12 <br /> Bulan
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-percent-p">00%</p>
                      <p className="card-label-p">Co-Pay</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-percent-p">100%</p>
                      <p className="card-label-p">Pembayaran</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <a aria-label="" href="/id#contact-us">
                      <Button
                        variant="contained"
                        sx={{
                          color: 'white',
                          fontSize: '18px',
                          fontFamily: 'matterMedium',
                          margin: '10px',
                          backgroundColor: '#950000',
                        }}
                      >
                        Hubungi Penjualan
                      </Button>
                    </a>
                  </div>
                </div>
                <div className="flexi-yearly">
                  <div className="flexi-card-header">
                    <h6 style={{ color: 'black' }}>
                      Rencana Pembayaran <br />
                      Satu Tahun
                    </h6>
                    <div className="flexi-card-headright">
                      <p>Mulai dari</p>
                      <span style={{ fontFamily: 'matter' }}>
                        IDR
                        <p
                          style={{
                            fontSize: '22px',
                            fontFamily: 'matterSemibold',
                          }}
                        >
                          4999
                        </p>
                      </span>
                    </div>
                  </div>
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        0-12 <br /> Bulan
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Pelanggan</p>
                      <p className="card-percent-p">00%</p>
                      <p className="card-label-p">Co-Pay</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Wisedrive</p>
                      <p className="card-percent-p">100%</p>
                      <p className="card-label-p">Pembayaran</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <a aria-label="" href="/id#contact-us">
                      <Button
                        variant="contained"
                        sx={{
                          color: 'white',
                          fontSize: '18px',
                          fontFamily: 'matterMedium',
                          margin: '10px',
                          backgroundColor: '#202020',
                        }}
                      >
                        Hubungi Penjualan
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
              <div className="flexi-note">
                <p>
                  * Co-Pay adalah persentase jumlah yang harus dibayar oleh
                  pelanggan untuk suku cadang garansi selama periode pembayaran
                  yang disebutkan. Silakan baca ketentuan garansi di
                  <a aria-label="" href=" https://wisedrive.com">
                    {' '}
                    https://wisedrive.com
                  </a>
                </p>
                <p>
                  ** Biaya penarikan dan penanganan harus dibayar secara
                  terpisah ditagih berdasarkan jarak mobil ditarik.
                </p>
              </div>
            </div>
          </>
        ),
      },
    ],
  },
  comparePage: {
    header: 'Wisedrive Lebih Unggul Dibandingkan Inspeksi Mobil Bekas Biasa',
    subTitle:
      'Rasakan ketenangan pikiran tanpa tanding dengan inspeksi menyeluruh WiseDrive, laporan terperinci, dan jaminan pelanggan terbaik untuk pembeli mobil bekas.',
    wiseDrivePoints: {
      header: 'Cara Wisedrive',
      content: [
        {
          point: (
            <p>
              Memeriksa mesin, transmisi, sistem kelistrikan, dan aspek mekanis
              secara menyeluruh,{' '}
              <span className="highlet">
                memastikan semua komponen penting dalam kondisi prima
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Menyediakan laporan inspeksi terperinci dengan{' '}
              <span className="highlet">
                foto berkualitas tinggi dan diagnostik,
              </span>
              memberikan wawasan jelas tentang kondisi mobil
            </p>
          ),
        },
        {
          point: (
            <p>
              Menggunakan{' '}
              <span className="highlet">pemeriksaan OBD-2, ECM, dan BCM</span>{' '}
              untuk kesehatan sistem, memastikan semua sistem elektronik
              berfungsi dengan baik.
            </p>
          ),
        },
        {
          point: (
            <p>
              Menyediakan <span className="highlet">saran personal</span> dan{' '}
              <span className="highlet">
                estimasi biaya perbaikan yang akurat
              </span>{' '}
              berdasarkan hasil inspeksi,{' '}
              <span className="highlet">
                membantu Anda memahami potensi biaya yang mungkin timbul
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Menawarkan <span className="highlet">garansi 6 bulan</span> dan{' '}
              <span className="highlet">jaminan pembelian kembali</span>,
              memberi Anda ketenangan pikiran dan keamanan finansial.
            </p>
          ),
        },
        {
          point: (
            <p>
              Memverifikasi{' '}
              <span className="highlet">
                keabsahan keuangan, status asuransi, tilang lalu lintas
              </span>{' '}
              serta <span className="highlet">catatan kriminal kendaraan</span>,
              memastikan tidak ada masalah finansial atau hukum tersembunyi.
            </p>
          ),
        },
      ],
    },
    comparePoints: {
      header: 'Inspeksi Biasa',
      content: [
        {
          point: (
            <p>
              Menawarkan inspeksi yang umumnya menyeluruh, meskipun{' '}
              <span className="highlet">
                kurang mendalam di beberapa aspek.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Menyediakan laporan dengan diagnostik, tetapi{' '}
              <span className="highlet">
                mungkin tidak selalu menyertakan bukti visual yang lengkap.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Menggunakan alat diagnostik, meskipun{' '}
              <span className="highlet">
                pemeriksaannya mungkin kurang menyeluruh dan konsisten.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Memberikan saran dan estimasi biaya, yang mungkin{' '}
              <span className="highlet">
                tidak selalu disesuaikan dengan kebutuhan pelanggan
              </span>{' '}
              dan cenderung lebih menguntungkan bengkel setelah pembelian.
            </p>
          ),
        },
        {
          point: (
            <p>
              Menyediakan garansi dan jaminan kepuasan, namun biasanya{' '}
              <span className="highlet">
                lebih singkat dan kurang komprehensif.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Memverifikasi keuangan dan asuransi, serta menawarkan beberapa
              pemeriksaan tambahan, meskipun{' '}
              <span className="highlet">
                mungkin tidak sedetail yang diperlukan.
              </span>
            </p>
          ),
        },
      ],
    },
  },

  onlyWhatsApp: {
    header: (
      <>
        <h2 className="whatsapp-mobile-header">
          Inspeksi Tanpa Bias, <br />
          Berbasis Teknologi, <br />
          Berorientasi pada Pelanggan, dan Canggih
        </h2>
        <h2 className="whatsapp-header">
          Inspeksi Tanpa Bias, Berbasis Teknologi, Berorientasi pada Pelanggan,
          dan Canggih
        </h2>
        <p>
          Di WiseDrive, Anda merasakan kualitas tak tertandingi dengan inspeksi
          yang tidak memihak, teknologi canggih, fokus utama pada pelanggan,
          serta metode mutakhir dalam pemeriksaan mobil bekas.
        </p>
      </>
    ),
    gradeCardsData: [
      {
        src: UnbiasedCustomer,
        header: 'Inspeksi Transparan & Berfokus pada Pelanggan',
        content:
          'Inspeksi kami sepenuhnya transparan dan tidak memihak, memberikan penilaian objektif yang hanya berfokus pada memastikan kualitas dan keandalan kendaraan tertinggi.',
      },
      {
        src: AiDrivenLogo,
        header: 'Analisis Suara Mesin Berbasis AI',
        content:
          'WiseDrive menggunakan kecerdasan buatan (AI) canggih untuk menganalisis suara mesin dengan membandingkan jutaan titik data dari mobil serupa di seluruh negeri.',
      },
      {
        src: OBDScanner,
        header: 'Analisis Lanjutan dengan Pemindai OBD-2',
        content:
          'Analisis Modul Kontrol Mesin (ECM), Modul Kontrol Bodi (BCM), dan Modul Kontrol Transmisi (TCM) pada mobil Anda menggunakan pemindai OBD-2 terbaru.',
      },
      // {
      //   src: BatteryIcon,
      //   header: "Inspeksi Terbaik di Industri",
      //   content:
      //     "WiseDrive menghadirkan layanan inspeksi terbaik di industri. Tim profesional bersertifikat kami melakukan pemeriksaan menyeluruh pada semua aspek kendaraan, dari sistem mekanis dan listrik hingga kondisi eksterior dan interior.",
      // },
      // {
      //   src: TurboWarrantyIcon,
      //   header: "Perpanjangan Asuransi",
      //   content: "Cakupan komprehensif untuk komponen turbo termasuk dalam layanan kami.",
      // },
      // {
      //   src: AcCompressorIcon,
      //   header: "Dukungan Klaim Asuransi",
      //   content: "Garansi komprehensif untuk komponen AC.",
      // },
      // {
      //   src: InsuranceClaimSuportIcon,
      //   header: "Detail Langganan",
      //   content: "Hubungi kami untuk dukungan klaim asuransi.",
      // },
      // {
      //   src: InsuranceClaimSuportIcon,
      //   header: "Detail Langganan",
      //   content: "Hubungi kami untuk dukungan klaim asuransi.",
      // },
    ],
  },

  brandGrade: {
    header: (
      <>
        <h2>Garansi Setara Showroom untuk Mobil Anda</h2>
        <p className="grade-description">
          Wisedrive bekerja sama dengan pusat layanan resmi dari semua merek
          mobil yang dijual di India dan memberikan cakupan garansi luas di
          seluruh negeri dengan tingkat persetujuan klaim 98% dalam waktu 24 jam
          setelah permintaan klaim. Kami menyediakan bantuan darurat di jalan
          dan layanan serta dukungan garansi di seluruh India bagi pelanggan
          garansi kami.
        </p>
      </>
    ),
    card1: {
      header: 'Komponen Listrik',
      content:
        'Garansi Kabel Listrik, Garansi Baterai, Garansi Sistem Infotainment, Garansi Lampu dan Bohlam.',
    },

    card2: {
      header: 'Komponen Mekanis',
      content: 'Suspensi, Shock Absorber, Lower Arm.',
    },
    card3: {
      header: (
        <h6 style={{ color: 'white' }}>
          Mesin & <br />
          Komponen Transmisi
        </h6>
      ),
      content:
        'Semua komponen mesin dan transmisi tercakup dalam program Garansi Komprehensif Wisedrive. Transmisi otomatis juga termasuk dalam program ini.',
      content1:
        'Kami mendukung inspeksi kami dengan Garansi GRATIS untuk mobil Anda.',
    },
    card4: {
      header: 'Bantuan Darurat di Jalan',
      content:
        'RSA (Roadside Assistance) termasuk dalam program Garansi Komprehensif.',
    },
    card5: {
      header: 'Garansi AC',
      content: 'Kompresor AC, Pendingin AC, Kabel, Kabel Konduktor AC.',
    },
  },

  queryPage: {
    header: (
      <div>
        <p className="query-sub-header">Bagaimana cara kerjanya?</p>
        <h2 style={{ color: 'black' }}>
          Membeli mobil bekas kini lebih{' '}
          <span style={{ color: '#003cc4' }}>Percaya Diri</span>!
        </h2>
        <p style={{ color: 'black' }}>
          Kirim pesan “HI” di WhatsApp ke 87840125467 untuk membeli paket
          inspeksi, memesan inspeksi,
          <br /> menjadwalkan ulang inspeksi, atau berbicara dengan ahli tentang
          mobil Anda.
          <strong> Kami hanya sejauh satu "Hi" untuk membantu Anda.</strong>
        </p>
      </div>
    ),
    cardsData: [
      {
        img: one,
        headder: 'Beli Paket Inspeksi',
        body: (
          <>
            <p>Pilih paket inspeksi terbaik untuk mobil Anda.</p>
            <p>
              Beli inspeksi sebelum membeli mobil untuk mendapatkan ketenangan
              pikiran setelah pembelian.
            </p>
          </>
        ),
      },
      {
        img: two,
        headder: 'Jadwalkan Inspeksi',
        body: (
          <>
            <p>
              Jadwalkan inspeksi secara online, melalui WhatsApp, atau hubungi
              kami di +62 87840125467 kapan saja.
            </p>
            <p>
              Anda dapat menjadwalkan inspeksi di mana saja di kota dengan
              mudah.
            </p>
          </>
        ),
      },
      {
        img: three,
        headder: 'Dapatkan Laporan dalam 2 Jam',
        body: (
          <>
            <p>
              Dapatkan laporan inspeksi mobil Anda dalam waktu 2 jam setelah
              inspeksi selesai.
            </p>
            <p>
              Kami akan mengirimkan laporan melalui tautan di WhatsApp yang
              dapat Anda klik untuk melihat laporan.
            </p>
          </>
        ),
      },
    ],
    advisory: (
      <>
        <p>
          Para ahli kami akan memberi saran mengenai semua permasalahan mobil
          dan membantu Anda memilih mobil yang tepat.
        </p>
        <p
          style={{
            color: '#003cc4',
            paddingTop: '0px',
            fontFamily: 'matterMedium',
          }}
        >
          Membeli mobil setelah Inspeksi Wisedrive memberikan Ketenangan
          Pikiran.
        </p>
      </>
    ),
  },
  pricePage: {
    header: (
      <>
        Kami menawarkan kualitas,{' '}
        <span style={{ fontFamily: 'matterThin' }}>
          dengan teknologi terbaik dan
          <br />
          ahli otomotif dalam inspeksi mobil
        </span>
      </>
    ),
    subTitle:
      'Dipercaya oleh 200.000+ pelanggan untuk memeriksa mobil bekas sebelum membeli',
    numberCardData: [
      {
        image: inspected,
        number: '200.000+',
        text: 'Pelanggan di seluruh India mempercayai kami sebelum membeli mobil bekas',
      },
      {
        image: warranty,
        number: '75.000+',
        text: 'Pelanggan membeli garansi kami setelah pembelian untuk kepemilikan bebas repot',
      },
      {
        image: kilometer,
        number: '80.00.000+',
        text: 'Kilometer yang telah ditempuh oleh pelanggan dengan garansi Wisedrive',
      },
      {
        image: cities,
        number: '10+ Kota',
        text: 'Dengan cakupan di 10+ kota, kami telah mencakup 7000+ kode pos di India',
      },
      {
        image: customerSupport,
        number: 'Layanan Pelanggan',
        text: 'Layanan pelanggan kami tersedia 24/7 untuk pertanyaan terkait garansi',
      },
      {
        image: roadsideAssist,
        number: 'Bantuan Pinggir Jalan',
        text: 'Terjebak di suatu tempat? Hubungi saluran bantuan kami untuk mendapatkan bantuan dalam 30 menit',
      },
    ],
  },
  contactUsPage: {
    header: 'Hubungi Kami',
    subTitle:
      'Whatsapp, telepon, atau isi formulir untuk mengetahui bagaimana Wisedrive dapat melindungi investasi Anda dalam membeli mobil bekas',
    email: 'support.id@wisedrive.com',
    mobile1: '+62 87840125467',
    mobile2: '+62 87840125467',
    dec1header: 'Layanan Pelanggan',
    dec1Content: (
      <>
        <p style={{ paddingTop: '0px' }}>PT Wisedrive Technologies Indonesia</p>
        <p style={{ paddingTop: '0px' }}>
          Mangkuluhur City Office Tower One Lantai
        </p>
        <p style={{ paddingTop: '0px' }}>
          19 Jalan Jenderal Gatot Subroto Lot.
        </p>
        <p style={{ paddingTop: '0px' }}> 1 Jakarta Selatan – Indonesia</p>
      </>
    ),
    dec2Header: 'Masukan dan Saran',
    dec2Content:
      'Kami menghargai masukan Anda dan terus bekerja untuk meningkatkan Wisedrive. Pendapat Anda sangat penting dalam membentuk masa depan inspeksi mobil bekas di India.',
    formHeader: 'Hubungi Kami',
    phoneCode: 62,
    formSubtitle: 'Anda dapat menghubungi kami kapan saja',
    fromLableName: 'Nama Anda',
    fromLableEmail: 'Email Anda',
    fromLablePhone: 'Nomor Telepon',
    fromLableHelpText: 'Bagaimana kami dapat membantu?',
    formBtnText: 'Kirim Pesan',
    formTerms: (
      <>
        Dengan menghubungi kami, Anda menyetujui
        <span style={{ fontFamily: 'matterBold' }}>
          {' '}
          Syarat dan Ketentuan{' '}
        </span>{' '}
        dan <span style={{ fontFamily: 'matterBold' }}>Kebijakan Privasi</span>
      </>
    ),
  },
  reviewPage: {
    header: 'Pengalaman dan Ulasan Pelanggan',
    subTitle:
      'Lihat bagaimana keahlian kami memastikan kepercayaan dalam setiap pembelian mobil bekas',
    reviewsData: [
      {
        reviewer_name: 'Mallikarjun',
        car: 'Hyundai i10',
        description:
          'Layanan inspeksi Wisedrive benar-benar mengubah permainan bagi saya! Saya melihat mobil bekas yang tampak sempurna, tetapi inspeksi mereka yang menyeluruh mengungkap beberapa masalah tersembunyi. Saya akhirnya bisa menegosiasikan harga yang lebih baik berkat laporan detail mereka. Sangat merekomendasikan!',
      },
      {
        reviewer_name: 'Nikita Sharma',
        car: 'Toyota Glanza',
        description:
          'Sebagai pembeli mobil pertama kali, saya merasa gugup membeli mobil bekas. Wisedrive membuat prosesnya jauh lebih mudah. Inspektur mereka tepat waktu, profesional, dan menjelaskan semuanya dengan istilah sederhana. Laporannya sangat lengkap, dan saya merasa percaya diri dengan pembelian saya.',
      },
      {
        reviewer_name: 'Dilip Patel',
        car: 'Maruti Swift',
        description:
          'Wisedrive menyelamatkan saya dari membeli mobil yang buruk! Mobilnya tampak bagus dari luar, tetapi inspektur menemukan beberapa masalah mekanis. Layanan mereka benar-benar sepadan jika Anda ingin terhindar dari penipuan saat membeli mobil bekas.',
      },
      {
        reviewer_name: 'Dharmesh Soni',
        car: 'MG Hector',
        description:
          'Saya sudah dua kali menggunakan Wisedrive, dan kedua kali mereka memberikan layanan luar biasa. Para inspektur sangat berpengetahuan dan tidak terburu-buru dalam prosesnya. Laporan detail mereka membantu saya membuat keputusan yang tepat. Layanan yang wajib digunakan bagi pembeli mobil bekas!',
      },
      {
        reviewer_name: 'Swati Gorakh',
        car: 'Skoda Octavia',
        description:
          'Sangat terkesan dengan Wisedrive! Inspektur sangat teliti dan menemukan beberapa masalah kecil yang tidak saya sadari. Penjual bahkan mengakui adanya beberapa hal kecil yang belum mereka ungkapkan. Saya merasa jauh lebih percaya diri dalam pembelian saya setelah menggunakan layanan ini.',
      },
      {
        reviewer_name: 'Rudra Gowda',
        car: 'Hyundai Venue',
        description:
          'Wisedrive adalah layanan yang wajib dimiliki jika Anda membeli mobil bekas. Laporan inspeksi mereka sangat rinci dan mudah dipahami. Inspektur benar-benar memeriksa setiap detail dengan teliti. Saya sangat senang telah menggunakan mereka sebelum melakukan pembelian.',
      },
      {
        reviewer_name: 'Chetana',
        car: 'Volkswagen Polo',
        description:
          'Awalnya saya ragu untuk melakukan inspeksi, tetapi saya sangat bersyukur telah melakukannya! Wisedrive menemukan masalah pada transmisi yang bisa menghabiskan biaya jutaan rupiah. Layanan mereka sangat bagus dan benar-benar layak untuk diinvestasikan.',
      },
      {
        reviewer_name: 'Gomti',
        car: 'Toyota Fortuner',
        description:
          'Saya selalu skeptis dalam membeli mobil bekas, tetapi Wisedrive membuat prosesnya bebas stres. Inspeksi mereka sangat menyeluruh, dan laporan yang diberikan membuat saya yakin bahwa saya membuat pembelian yang baik. Sangat merekomendasikan untuk siapa saja yang membeli mobil bekas!',
      },
      {
        reviewer_name: 'Naduvinahalli Kariyappa',
        car: 'Ford Endeavour',
        description:
          'Inspektur dari Wisedrive sangat ramah, profesional, dan sangat teliti. Laporan mereka mencakup semua informasi yang saya butuhkan, dan layanan pelanggan mereka luar biasa. Saya merasa lebih tenang karena memiliki semua informasi sebelum membeli.',
      },
      {
        reviewer_name: 'Rajat Chaudhry',
        car: 'Mahindra Scorpio',
        description:
          'Layanan inspeksi Wisedrive luar biasa! Mereka memberikan laporan detail yang membantu saya menegosiasikan harga lebih baik. Inspektur mereka sangat berpengetahuan dan menjawab semua pertanyaan saya. Saya pasti akan menggunakan mereka lagi untuk pembelian mobil di masa depan.',
      },
    ],
    buttonText: '1500+ ulasan di Google',
  },
  faqPage: {
    header: 'Pertanyaan yang Sering Diajukan',
    subtitle:
      'Semua yang perlu Anda ketahui tentang produk dan penagihan. Tidak menemukan jawaban yang Anda cari? Hubungi Kami',
    faqData: [
      {
        question:
          'Layanan apa saja yang ditawarkan Wisedrive untuk inspeksi mobil bekas?',
        answer:
          'Wisedrive menawarkan inspeksi mobil bekas yang komprehensif, mencakup komponen penting seperti mesin, transmisi, rem, dan sistem kelistrikan.',
      },
      {
        question: 'Bagaimana cara saya memesan inspeksi mobil?',
        answer:
          'Anda dapat memesan inspeksi melalui situs web atau aplikasi seluler kami dengan memilih paket yang diinginkan dan menjadwalkan janji temu.',
      },
      {
        question:
          'Apa saja yang termasuk dalam inspeksi mobil bekas Wisedrive?',
        answer:
          'Inspeksi kami mencakup lebih dari 200 titik pengecekan, termasuk sistem mekanis, kelistrikan, dan keselamatan.',
      },
      {
        question: 'Bagaimana proses inspeksi berlangsung?',
        answer:
          'Teknisi bersertifikat akan memeriksa mobil Anda di lokasi Anda atau bengkel mitra, lalu memberikan laporan rinci setelahnya.',
      },
      {
        question: 'Berapa lama waktu yang dibutuhkan untuk inspeksi mobil?',
        answer:
          'Inspeksi biasanya memakan waktu sekitar 1-2 jam, tergantung pada kondisi kendaraan dan paket yang dipilih.',
      },
      {
        question: 'Bisakah saya meminta inspeksi untuk semua jenis kendaraan?',
        answer:
          'Kami melakukan inspeksi pada sebagian besar jenis kendaraan, termasuk sedan, SUV, dan truk.',
      },
      {
        question: 'Berapa biaya inspeksi mobil bekas?',
        answer:
          'Biaya bervariasi berdasarkan paket yang dipilih. Informasi harga lengkap tersedia di situs web kami.',
      },
      {
        question: 'Jenis garansi apa saja yang ditawarkan Wisedrive?',
        answer:
          'Kami menawarkan berbagai paket garansi yang mencakup berbagai aspek perawatan dan perbaikan kendaraan.',
      },
      {
        question: 'Bagaimana cara membeli garansi bersamaan dengan inspeksi?',
        answer:
          'Anda dapat menambahkan garansi ke paket inspeksi selama proses pemesanan di situs web atau aplikasi kami.',
      },
      {
        question: 'Apa saja yang dicakup dalam garansi Wisedrive?',
        answer:
          'Cakupan bervariasi tergantung pada paket, tetapi umumnya mencakup komponen utama seperti mesin, transmisi, dan sistem kelistrikan.',
      },
      {
        question: 'Apakah ada pengecualian dalam cakupan garansi?',
        answer:
          'Ya, beberapa pengecualian berlaku. Silakan merujuk ke syarat dan ketentuan garansi untuk detail lebih lanjut.',
      },
      {
        question: 'Bagaimana cara mengajukan klaim garansi dengan Wisedrive?',
        answer:
          'Hubungi tim dukungan kami untuk mengajukan klaim, dan kami akan memandu Anda melalui prosesnya serta mengarahkan Anda ke pusat layanan resmi.',
      },
      {
        question:
          'Bisakah saya mentransfer garansi ke pemilik baru jika saya menjual mobil saya?',
        answer:
          'Ya, garansi dapat dialihkan ke pemilik baru untuk memastikan cakupan tetap berlanjut.',
      },
      {
        question: 'Berapa lama masa berlaku garansi Wisedrive?',
        answer:
          'Masa berlaku garansi bervariasi tergantung pada paket dan dapat berkisar dari 6 bulan hingga beberapa tahun.',
      },
    ],
  },
  footerPage: {
    subTitle:
      'Wisedrive adalah penyedia inspeksi mobil bekas dan garansi mobil bekas pertama di India dengan teknologi AI canggih dalam industri garansi otomotif. Wisedrive memimpin industri inspeksi mobil bekas dengan kehadiran di 30 kota di India.',
    footerLinkProducts: {
      header: 'Produk',
      links: [
        {
          link: '#inspection-plans',
          label: 'Inspeksi Mobil',
          type: 'anchor',
        },
        {
          link: '#inspection-plans',
          label: 'Garansi Mobil Bekas',
          type: 'anchor',
        },
        {
          link: '/',
          label: 'Servis & Perawatan Mobil',
          type: 'link',
        },
        {
          link: '/id',
          label: 'Perbaikan & Perawatan Mobil',
          type: 'link',
        },
        {
          link: '/id#inspection-plans',
          label: 'Inspeksi Mobil Mewah',
          type: 'anchor',
        },
      ],
    },
    footerLinkCompany: {
      header: 'Perusahaan',
      links: [
        {
          link: '/id/about-wisedrive',
          label: 'Tentang Kami',
          type: 'link',
        },
        {
          link: '/id#how-it-works',
          label: 'Bagaimana cara kerjanya?',
          type: 'anchor',
        },
        {
          link: '/id#contact-us',
          label: 'Hubungi Kami',
          type: 'anchor',
        },
        {
          link: '/id',
          label: 'Kunjungi Kami',
          type: 'link',
        },
      ],
    },
    footerLinkResources: {
      header: 'Sumber Daya',
      links: [
        {
          link: '/id',
          label: 'Blog',
          type: 'link',
        },
        {
          link: '/id',
          label: 'Media Sosial',
          type: 'link',
        },
        {
          link: '/id',
          label: 'Buletin',
          type: 'link',
        },
        {
          link: '/id#contact-us',
          label: 'Dukungan',
          type: 'anchor',
        },
        {
          link: '/id#contact-us',
          label: 'Pusat Bantuan',
          type: 'anchor',
        },
      ],
    },
    footerLinkPolicies: {
      header: 'Kebijakan & Ketentuan',
      links: [
        {
          link: '/id/inspection-terms-and-conditions',
          label: 'Syarat dan Ketentuan Inspeksi',
          type: 'link',
        },
        {
          link: '/id/warrantyPolicy',
          label: 'Syarat dan Ketentuan Garansi',
          type: 'link',
        },
        {
          link: '/id/cancellation_refund_policy',
          label: 'Kebijakan Pembatalan & Pengembalian Dana',
          type: 'link',
        },
        {
          link: '/id/terms-and-conditions',
          label: 'Syarat dan Ketentuan',
          type: 'link',
        },
        {
          link: '/id/privacy',
          label: 'Kebijakan Privasi',
          type: 'link',
        },
      ],
    },
    footerCopyRight:
      '© PT Wisedrive Technologies Indonesia. All rights reserved 2025',
    footerCopyRightMobile: (
      <>
        © PT Wisedrive Technologies Indonesia. <br />
        All rights reserved 2025
      </>
    ),
  },
  aboutUsPage: {
    header: 'Tentang Kami',
    leftHeader: (
      <>
        Misi kami adalah <br />
        menjamin
        <br /> ketenangan pikiran <br />
        bagi pembeli mobil bekas
      </>
    ),
    rightContent:
      'WiseDrive adalah perusahaan Generative AI pertama di India yang menyediakan layanan inspeksi mobil bekas inovatif serta layanan garansi diperpanjang tingkat showroom untuk mobil bekas di India. Kami telah bermitra dengan layanan yang diotorisasi OEM untuk memberikan layanan terbaik bagi pelanggan garansi kami setelah pembelian, menjamin ketenangan pikiran. Kami menyediakan inspeksi pihak ketiga yang independen & objektif dengan AI terbaik di industri otomotif serta inspeksi mobil bekas yang transparan dan akurat.',
    cardContent: [
      {
        header: '200.000+',
        description: 'Inspeksi Mobil Bekas',
        subTitle: 'Pelanggan yang membeli layanan inspeksi kami',
      },
      {
        header: '75.000+',
        description: 'Garansi Mobil Bekas',
        subTitle: 'Pelanggan garansi aktif di India',
      },
      {
        header: '80.00.000+',
        description: 'Kepercayaan pada WiseDrive',
        subTitle: 'Kilometer yang telah ditempuh oleh pelanggan kami yang puas',
      },
      {
        header: '20 Kota',
        description: '7000+ Kode Pos',
        subTitle: 'Kami menyediakan inspeksi di 20 kota di India',
      },
    ],
    headerDesc: 'Misi Kami',
    header2: 'Bagaimana kami menjamin ketenangan pikiran?',
    subTitle:
      'Kami memulai dengan menginspeksi mobil Anda sebelum Anda membelinya',
    missionLeftContent:
      'WiseDrive berkomitmen untuk melindungi pembeli mobil bekas dari risiko membeli kendaraan yang tidak dapat diandalkan. Proses kami dimulai dengan inspeksi menyeluruh pada setiap mobil, memastikan kendaraan memenuhi standar kualitas ketat kami. Hanya kendaraan yang lolos inspeksi yang mendapatkan segel persetujuan WiseDrive. Sebagai bagian dari komitmen kami terhadap kepuasan pelanggan, setiap mobil yang disetujui mendapatkan garansi gratis selama 60 hari. Perlindungan awal ini memberikan ketenangan pikiran dan kepercayaan diri bagi pembeli dalam pembelian mereka.',
    missionLeftHeader: 'Begini cara kerjanya:',
    missionLeftPoints: [
      'Inspeksi Menyeluruh: Setiap mobil diperiksa secara ketat untuk mengidentifikasi dan mengatasi potensi masalah.',
      'Garansi Gratis 60 Hari: Kendaraan yang disetujui dilengkapi dengan perlindungan ini, memberikan perlindungan langsung terhadap perbaikan yang tidak terduga.',
      'Opsi Garansi Diperpanjang: Setelah 60 hari pertama, pelanggan memiliki opsi untuk memperpanjang garansi dan terus menikmati perlindungan.',
    ],
    missionRightContent:
      'Selain memberikan perlindungan saat pembelian, modul layanan dan perawatan WiseDrive memastikan kesehatan kendaraan dalam jangka panjang. Melalui platform kami, pelanggan dapat dengan mudah melacak riwayat perawatan kendaraan, menerima pengingat untuk layanan yang akan datang, dan bahkan memesan janji temu dengan penyedia layanan terpercaya.',
    missionRightHeader: 'Fitur perawatan kami meliputi:',
    missionRightPoints: [
      'Pengingat Layanan: Jangan lewatkan tugas perawatan penting seperti penggantian oli, rotasi ban, atau pemeriksaan rem.',
      'Pemesanan Mudah: Jadwalkan janji perawatan langsung melalui platform dengan pusat layanan yang telah diverifikasi.',
      'Pelacakan Riwayat Perawatan: Simpan semua catatan dalam satu tempat untuk organisasi yang lebih baik dan meningkatkan nilai jual kembali kendaraan.',
    ],
    missionRightFooter:
      'Dengan menggabungkan inspeksi menyeluruh, perlindungan garansi, dan dukungan perawatan berkelanjutan, WiseDrive tidak hanya membantu pembeli menghindari mobil yang buruk tetapi juga memastikan kendaraan mereka tetap dalam kondisi prima, meningkatkan keselamatan dan keandalan dalam jangka panjang.',
  },
  inspectionTerms: {
    header: 'Syarat & Ketentuan Inspeksi',
    contentArray: [
      {
        data: (
          <>
            <strong>Kami/Kita dan Kami </strong>
            berarti PT Wisedrive Technologies Indonesia
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Perjanjian </strong>berarti perjanjian antara Wisedrive dan
            Pelanggan di mana Wisedrive setuju untuk memastikan bahwa seorang
            Inspektur melakukan Inspeksi sesuai dengan syarat dan ketentuan ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Biaya Pembatalan </strong>berarti jumlah yang harus
            dibayarkan oleh Pelanggan sebagaimana disebutkan dalam syarat dan
            ketentuan ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pelanggan/Anda </strong>berarti pelanggan Wisedrive yang
            melakukan pemesanan untuk Inspeksi.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Biaya </strong>berarti jumlah yang harus dibayarkan oleh
            Pelanggan kepada Wisedrive untuk Inspeksi sebagaimana tercantum di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspeksi </strong>berarti pemeriksaan eksternal kendaraan
            secara audio-visual dan uji coba yang dilakukan oleh Inspektur atas
            nama Wisedrive untuk Pelanggan sesuai dengan syarat dan ketentuan
            ini.
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive menyediakan berbagai kategori Inspeksi, masing-masing
            dengan pemeriksaan yang berbeda. Detail kategori inspeksi dan
            pemeriksaan yang dilakukan tersedia di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            &nbsp; atau dengan menghubungi +62 87840125467. Konfirmasi kategori
            Inspeksi yang telah dipilih oleh Pelanggan untuk dilakukan pada
            Kendaraan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspektur </strong>mengacu pada inspektur yang
            berkualifikasi yang melakukan Inspeksi atas nama Wisedrive.
            Ketersediaan inspektur bergantung pada kondisi dan dapat didukung
            oleh agen pihak ketiga yang sesuai.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Laporan </strong>berarti laporan tertulis yang dibuat oleh
            Inspektur sebagai bagian dari Inspeksi, yang mencakup nama dan
            alamat Pelanggan, detail registrasi kendaraan yang diperiksa dan
            lokasinya, apakah kendaraan tersebut lulus atau gagal Inspeksi,
            daftar pemeriksaan yang dilakukan (tergantung pada jenis Inspeksi
            yang diminta oleh Pelanggan), serta ringkasan area yang perlu
            diperhatikan sebagaimana ditentukan oleh Inspektur untuk
            diinformasikan kepada Pelanggan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Daftar Periksa Laporan </strong>berarti daftar area yang
            akan atau telah diperiksa oleh Inspektur sebagai bagian dari
            Inspeksi Fisik, yang tersedia di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Kendaraan </strong>berarti kendaraan yang akan diperiksa
            oleh Inspektur atas permintaan Pelanggan.
          </>
        ),
      },
    ],
    subHeader: 'Umum',
    listContent: [
      'Inspeksi dilakukan berdasarkan pemeriksaan visual dan eksternal kendaraan saja serta terbatas pada bagian dan/atau item yang tercantum dalam Laporan. Inspeksi tidak melibatkan pembongkaran atau gangguan terhadap struktur, rakitan, komponen, atau mekanisme internal apa pun. Inspektur akan melakukan uji jalan terhadap Kendaraan dan membuat Laporan. Ada beberapa bagian Kendaraan yang tidak akan diperiksa. Anda harus membaca Daftar Periksa Laporan dengan cermat untuk melihat apa saja yang tidak diperiksa.',
      'Salinan Laporan akan dikirim kepada Anda melalui email ke alamat email yang Anda berikan saat memesan Inspeksi. Karena sifat internet dan perangkat lunak perlindungan virus yang digunakan oleh penyedia layanan internet Anda atau yang terinstal di komputer Anda, dalam beberapa kasus mungkin tidak memungkinkan untuk menjamin pengiriman Laporan melalui email. Jika Anda tidak menerima Laporan Anda dalam waktu 24 jam setelah Inspeksi Kendaraan Wisedrive dilakukan, Anda harus segera memberi tahu Kami agar Kami dapat mengirim ulang Laporan kepada Anda. Kami tidak bertanggung jawab kepada Anda atas kegagalan pengiriman Laporan sejauh kegagalan tersebut berada di luar kendali wajar Kami.',
      'Item yang tercantum dalam Daftar Periksa Laporan sebagai bagian/item yang akan diperiksa, tetapi tidak dapat diakses secara wajar pada Kendaraan, tidak akan diperiksa. Dalam keadaan seperti itu, Kami tidak memiliki kewajiban untuk memeriksa dan/atau melaporkan bagian/item tersebut, dan Inspektur akan menandai bagian terkait dalam Laporan sesuai dengan kondisi tersebut.',
      'Kendaraan harus dalam kondisi yang cukup bersih agar Inspektur dapat melihat dengan jelas dan melaporkan dengan akurat bagian kendaraan yang diperiksa. Jika kendaraan tidak bersih, Inspektur berhak untuk tidak memberikan komentar mengenai bagian tersebut dan akan menandai Daftar Periksa Laporan sesuai dengan kondisi tersebut. Dalam hal ini, Biaya Laporan tetap harus dibayar penuh.',
    ],

    subHeader1: 'Pengecualian',
    subTitle: 'Item yang Tidak Kami Periksa adalah:',
    listExcluded: [
      'Bagian yang memerlukan pembongkaran/pelepasan/pemisahan atau pencopotan untuk tujuan inspeksi',
      'Pemeriksaan data kendaraan',
      'Konsumsi oli dan bahan bakar',
      'Sumber kebocoran oli',
      'Material lapisan rem (selain yang dapat langsung terlihat tanpa membongkar apa pun)',
      'Kontaminasi cairan rem. Cairan rem akan mengalami penurunan kualitas seiring waktu, dan Kami menyarankan agar diganti sesuai rekomendasi pabrikan kendaraan',
      'Pengoperasian pemutar kaset, pemutar CD, sistem TV/DVD/navigasi satelit, Bluetooth, atau sistem hiburan dalam mobil lainnya',
      'Suara atau penerimaan radio serta sistem alarm',
      'Kompresi silinder, sistem listrik dan elektronik kendaraan yang memerlukan peralatan diagnostik khusus',
      'Emisi gas buang dan/atau catalytic converter. Jika dinyatakan lulus inspeksi oleh Inspektur, ini hanya mencakup kondisi eksternal, ketahanan terhadap kebocoran gas, dan keamanan. Inspektur tidak dapat mengonfirmasi kondisi internal atau efektivitasnya karena hal ini memerlukan pengujian emisi gas buang yang tidak termasuk dalam Inspeksi',
      'Akurasi sistem komputer dalam kendaraan (misalnya, namun tidak terbatas pada, komputer yang digunakan untuk navigasi, efisiensi bahan bakar, atau lainnya)',
      'Emisi gas buang',
      'Fungsi dan efisiensi sistem pendingin udara',
      'Area hunian pada Motorhome - Sistem listrik dan peralatan, perlengkapan air dan peralatan, serta perlengkapan gas dan peralatan tidak diperiksa. Hal ini berada di luar cakupan Inspeksi. Kami sangat menyarankan agar bagian-bagian ini diuji dan diperiksa oleh orang yang memiliki kualifikasi yang sesuai sebelum pembelian',
      'Sistem Teknis Kendaraan - Banyak kendaraan dilengkapi dengan sistem operasi otomatis atau terkomputerisasi yang dikendalikan oleh mikroprosesor. Ini termasuk sistem manajemen mesin, sistem bahan bakar, sistem pengapian, sistem pendingin udara, sistem lambda-control, radio stereo, kaset, amplifier, CD (single dan multi), TV/DVD, navigasi satelit, suspensi aktif dan self-leveling, gearbox, turbocharger dan supercharger, sistem pengereman anti-lock, sistem penggerak empat roda dan unit diferensial elektronik yang dapat dikunci, kontrol traksi, sistem alarm dan immobilizer, sistem pembuangan katalitik, serta sistem variabel camshaft timing.',
      'Dalam cakupan Inspeksi, tidak memungkinkan untuk sepenuhnya memeriksa operasi terperinci dari sistem-sistem ini karena banyaknya variasi fitur dan mode pengoperasian, serta tidak mungkin untuk mengonfirmasi bahwa sistem-sistem ini berfungsi sepenuhnya sesuai dengan spesifikasi desain pabrikan. Oleh karena itu, Inspektur hanya dapat memberikan gambaran umum dan opini terhadap kinerja secara keseluruhan dari sistem yang diperiksa. Dengan demikian, Kami tidak dapat bertanggung jawab kepada Anda atas kegagalan dalam mengidentifikasi kerusakan atau kegagalan sistem-sistem ini untuk berfungsi sesuai dengan spesifikasi yang dirancang oleh pabrikan.',
      'Aksesori non-standar sebagai akibat dari modifikasi pribadi atau lainnya',
    ],
    subheader2: (
      <p>
        Selain itu, <strong>Inspeksi tidak dapat: </strong>
      </p>
    ),
    inspectionCannotListItems: [
      'a) memastikan apakah kompartemen penumpang atau bagasi (termasuk area bodi atau karavan dari Motorhome) kedap air atau tidak',
      'b) memprediksi masa pakai sistem knalpot, kopling, atau flywheel dual-mass',
      'c) memberikan indikasi adanya kerusakan yang mungkin terlihat jika Kendaraan dikendarai melebihi kecepatan atau jarak tempuh selama uji jalan yang dilakukan oleh Inspektur',
      'd) memastikan bahwa semua atau sebagian komponen Kendaraan adalah komponen asli, atau komponen pengganti yang diproduksi oleh pabrikan kendaraan',
      'e) mencakup inspeksi terhadap bagian, komponen, atau area Kendaraan yang tidak dapat dilihat atau diakses secara wajar oleh Inspektur pada saat Inspeksi',
      'f) memastikan keaslian Dokumen Registrasi Kendaraan, jarak tempuh, Pajak Kendaraan, Nomor Identifikasi Kendaraan (VIN), Nomor Mesin, Nomor Registrasi, atau riwayat servis Kendaraan',
      'g) memeriksa adanya pemberitahuan penarikan kembali (recall). Wisedrive menyarankan Anda untuk memeriksa dengan RTO atau pabrikan apakah Kendaraan tersebut telah dikenakan pemberitahuan semacam itu.',
    ],

    listContent1: [
      <>
        <strong>Inspeksi hanya dapat </strong>mendeskripsikan dan/atau
        mengidentifikasi cacat yang benar-benar ditemukan dan/atau yang secara
        wajar dapat ditemukan melalui pemeriksaan visual eksternal terhadap
        Kendaraan pada saat Inspeksi. Kami tidak dapat bertanggung jawab atas
        cacat tersembunyi yang ditemukan kemudian, kecuali jika secara wajar
        Kami seharusnya dapat melihatnya selama Inspeksi yang dilakukan sesuai
        dengan syarat dan ketentuan ini. Kami tidak dapat memberi tahu adanya
        cacat jika kami tidak dapat melihatnya, atau jika cacat tersebut tidak
        tampak selama Inspeksi terhadap Kendaraan. Secara khusus, harap
        diperhatikan bahwa (tanpa membatasi hal tersebut) Kendaraan yang berusia
        lebih dari 5 tahun, memiliki jarak tempuh tinggi, dan/atau telah
        digunakan secara tidak normal mungkin memiliki cacat tersembunyi.
        Meskipun cacat tersebut dalam beberapa kondisi tertentu dapat menjadi
        dasar klaim terhadap penjual Kendaraan, namun hal tersebut berada di
        luar cakupan Inspeksi dan Laporan disediakan berdasarkan ketentuan ini.
        Wisedrive maupun Inspektur tidak akan bertanggung jawab kepada Anda
        akibat adanya cacat tersebut.
      </>,
      <>
        <strong>Harap diperhatikan </strong>bahwa kendaraan bekas mungkin
        memiliki cacat internal, struktural, atau mekanis yang serius dan/atau
        korosi tersembunyi, yang tidak dapat dideteksi hanya melalui pemeriksaan
        visual eksternal. Kendaraan semacam itu mungkin kurang dapat diandalkan
        dan mungkin memerlukan perbaikan/servis lebih sering dibandingkan
        kendaraan yang lebih baru. Meskipun Inspektur Kami berusaha
        mengidentifikasi potensi masalah dengan Kendaraan melalui pemeriksaan
        visual eksternal, Anda menerima risiko dan konsekuensi memiliki
        kendaraan bekas dan setuju bahwa Wisedrive maupun Inspektur tidak akan
        bertanggung jawab atas adanya cacat tersebut.
      </>,
      'Jika tidak ada bukti dokumentasi penggantian timing belt (cam belt) mesin baru-baru ini, Kami menyarankan agar sabuk Kendaraan diperiksa atau diganti sebelum pembelian.',
      'Jika Kendaraan tidak memiliki riwayat servis terbaru atau riwayat tersebut tidak tersedia bagi Inspektur pada saat Inspeksi, maka Kami menyarankan agar servis dilakukan sesuai spesifikasi pabrikan Kendaraan sebelum pembelian. Hal ini dapat mengungkapkan cacat lain yang tidak tampak dalam pemeriksaan visual eksternal oleh Inspektur.',
      <>
        <strong>Harap diperhatikan </strong>bahwa masa pakai sistem knalpot atau
        kopling tidak pasti dan sulit diprediksi. Fakta bahwa item tersebut
        tidak teridentifikasi sebagai rusak dalam Laporan tidak berarti atau
        tidak boleh diartikan bahwa sistem tersebut akan tetap berfungsi dalam
        jangka waktu tertentu setelah pemeriksaan Kami.
      </>,
    ],

    subHeader3: (
      <>
        <strong>Uji Jalan </strong>
      </>
    ),
    listContent2: [
      <>
        Agar Inspektur Kami dapat melakukan Uji Jalan terhadap Kendaraan, Anda
        harus memastikan bahwa kendaraan memiliki cukup:
        <br /> (a) Air; <br /> (b) Oli;
        <br /> (c ) Bensin.
      </>,
      'Uji jalan dilakukan di area sekitar lokasi Inspeksi. Jika:',
      'Kendaraan dalam kondisi tidak layak jalan atau tidak memiliki cukup oli, air, dan/atau bensin',
      'Pelanggan tidak dapat memastikan bahwa Kendaraan memiliki sertifikat kelayakan yang sah sehingga uji jalan tidak dapat dilakukan pada saat Inspeksi',
      'Biaya Inspeksi tetap harus dibayar penuh, dan Biaya tambahan akan dikenakan untuk setiap uji jalan tambahan yang Anda minta Kami lakukan.',
      'Pelaksanaan uji jalan tidak berarti bahwa Inspektur Kami telah melihat sertifikat kelayakan yang valid. Mendapatkan izin yang diperlukan, akses ke Kendaraan, dll.',
      'Menjadi tanggung jawab Pelanggan untuk memastikan bahwa semua persiapan yang diperlukan telah dilakukan (termasuk mendapatkan izin yang diperlukan dari pemilik Kendaraan) agar Inspeksi dapat dilakukan di bengkel atau lokasi off-road dengan area datar, keras, dan kering. Inspektur Kami memerlukan cukup ruang untuk dapat berjalan mengelilingi Kendaraan dan membuka semua pintu sepenuhnya. Juga harus tersedia cukup ruang bagi Inspektur Kami untuk memarkir kendaraannya sendiri di dekat lokasi Inspeksi.',
      'Pencahayaan dalam ruangan yang baik atau cahaya alami (jika Kendaraan diperiksa di luar ruangan) harus tersedia di lokasi Inspeksi. Kami tidak dapat memeriksa Kendaraan dalam kondisi pencahayaan yang buruk atau gelap.',
    ],

    subHeader4: 'Biaya dan Pembatalan',
    listContent3: [
      'Biaya harus dibayarkan pada saat pemesanan Inspeksi.',
      <>
        Kami berhak menolak untuk melakukan Inspeksi atau mengeluarkan Laporan
        untuk kendaraan yang: Inspektur tidak dapat mengakses secara wajar; atau
        tampaknya bagi Inspektur:
        <br /> (a) bukan kendaraan produksi standar (misalnya, tetapi tidak
        terbatas pada, mobil rakitan sendiri);
        <br /> (b) telah dimodifikasi atau tidak digunakan secara teratur
        (misalnya, menunjukkan tanda-tanda korosi berlebihan pada bagian yang
        bergerak karena lama tidak digunakan dan dapat menyebabkan Kendaraan
        tidak aman untuk dikendarai tanpa perbaikan);
        <br /> (c) tidak layak jalan atau tidak aman untuk dikendarai.
      </>,
      'Dalam keadaan yang disebutkan dalam syarat dan ketentuan ini.',
      'Jika Pelanggan gagal memastikan bahwa persiapan yang tepat telah dilakukan agar Inspeksi dapat dilaksanakan sebagaimana diwajibkan.',
      'Jika Pelanggan memberikan informasi yang salah atau tidak lengkap yang menghalangi Kami melakukan Inspeksi, dan Anda memahami bahwa dalam keadaan seperti itu Kami berhak menganggap Perjanjian berakhir dan menahan Biaya secara penuh. Jika Anda ingin Kami melakukan Inspeksi ulang, Anda harus membayar Biaya tambahan saat pemesanan.',
      'Anda berhak membatalkan Inspeksi dan menerima pengembalian dana penuh jika pembatalan dilakukan 24 jam sebelum jadwal Inspeksi. Setelah Inspeksi dilakukan, tidak ada pengembalian dana yang akan diberikan.',
      'Untuk membatalkan Inspeksi, Anda harus memberi tahu Tim Dukungan Layanan Kami tentang keputusan Anda dengan mengirim email ke support.id@wisedrive.com atau menghubungi +62 87840125467, Senin hingga Jumat pukul 9 pagi hingga 5 sore. Untuk membantu Kami menemukan pesanan Anda, Anda harus memberikan nama, alamat, nomor telepon, dan referensi pemesanan Anda (seperti yang diberikan dalam konfirmasi pemesanan Anda) bersama dengan permintaan pembatalan Anda.',
    ],
    subHeader5: 'Keluhan',
    listContent4: [
      'Jika Anda memiliki keluhan atau tidak puas dengan Inspeksi yang telah dilakukan, silakan hubungi Kami di +62 87840125467 sesegera mungkin. Kami mungkin perlu melakukan inspeksi ulang terhadap Kendaraan untuk menangani keluhan tersebut, dan Anda setuju untuk mengizinkan Kami melakukannya.',
      'Tidak boleh ada perbaikan yang dilakukan atau penggantian suku cadang pada Kendaraan yang menjadi subjek keluhan sebelum Kendaraan telah diperiksa ulang oleh Kami. Jika perbaikan darurat diperlukan untuk membuat Kendaraan aman dan kemudian menjadi subjek keluhan kepada Kami, maka Anda harus memastikan bahwa keluhan diajukan kepada Kami (termasuk pemberitahuan tentang perlunya melakukan perbaikan darurat) dalam waktu yang wajar setelah menemukan masalah tersebut, serta memastikan bahwa suku cadang yang rusak atau aus yang telah diperbaiki atau diganti disimpan untuk pemeriksaan ulang oleh Kami di masa mendatang. Kami tidak akan bertanggung jawab, dalam keadaan apa pun, atas biaya perbaikan atau penggantian suku cadang yang dilakukan tanpa persetujuan tertulis dari Kami sebelumnya.',
      'Kami berhak meminta Inspektur lain dari tim Kami untuk melakukan inspeksi ulang terhadap Kendaraan atas biaya Kami sendiri jika Kami menganggap hal itu perlu untuk menangani keluhan tersebut, dan Anda diwajibkan untuk mengizinkan Inspektur Kami melakukannya sesuai dengan syarat dan ketentuan ini. Kami akan memberikan pendapat kedua yang tidak bias terhadap Laporan awal yang telah diterbitkan.',
    ],

    subHeader6: 'Hal di luar kendali Kami yang wajar',
    listContent5: [
      'Kami tidak akan bertanggung jawab atas keterlambatan atau kegagalan dalam melakukan Inspeksi akibat peristiwa atau keadaan di luar kendali Kami yang wajar. Kami akan berusaha untuk meminimalkan dampak dari keadaan tersebut sejauh mungkin.',
      'Wisedrive hanya akan bertanggung jawab kepada Pelanggan (dan bukan kepada pihak lain) sejauh Wisedrive gagal melakukan Inspeksi sesuai dengan syarat dan ketentuan ini. Tanpa membatasi hal tersebut, Anda mengakui bahwa baik Wisedrive maupun Inspektur tidak akan bertanggung jawab kepada Anda atau pihak lain atas tanggung jawab, kerugian, kerusakan, klaim, tuntutan, biaya, atau pengeluaran (secara bersama-sama disebut sebagai “Kerugian”) yang dialami atau diderita dalam situasi berikut:',
      'Kerugian tersebut bukan akibat yang dapat diperkirakan secara wajar dari pelanggaran tersebut (Kerugian dapat diperkirakan jika dapat dipertimbangkan oleh Anda dan Kami pada saat Kendaraan diperiksa).',
      'Kerugian tersebut tidak secara langsung disebabkan oleh pelanggaran yang dilakukan oleh Kami atau Inspektur terhadap syarat dan ketentuan ini.',
      'Kerugian tersebut merupakan kerugian bisnis atau kerugian lain yang dialami oleh pelanggan yang bukan konsumen.',
      'Kerugian tersebut meningkat akibat pelanggaran yang dilakukan oleh Anda terhadap salah satu syarat dan ketentuan ini.',
      'Tidak ada dalam ketentuan ini yang akan mempengaruhi hak-hak hukum seorang konsumen berdasarkan undang-undang yang berlaku.',
    ],

    subHeader7: 'Penegakan syarat dan ketentuan',
    listContent6: [
      'Setiap klausul dalam syarat dan ketentuan ini berlaku secara terpisah. Jika ada pengadilan dengan kewenangan yang relevan memutuskan bahwa salah satu klausul ini tidak sah, klausul lainnya akan tetap berlaku sepenuhnya.',
      'Perjanjian ini berlaku antara Anda dan Wisedrive. Tidak ada pihak lain yang memiliki hak untuk menegakkan salah satu ketentuannya. Baik Anda maupun Kami tidak perlu mendapatkan persetujuan dari pihak lain untuk membuat perubahan pada syarat dan ketentuan ini.',
    ],

    subHeader8: 'Saran mengenai Laporan',
    listContent7: [
      'Kami sangat menyarankan Anda untuk mendiskusikan temuan yang terdapat dalam Laporan dengan penjual sebelum membuat keputusan untuk membeli Kendaraan. Jika Anda belum melihat Kendaraan secara langsung, Anda harus memastikan bahwa tampilan kosmetik dan spesifikasinya sesuai dengan kebutuhan dan harapan Anda. Kami menyarankan Anda untuk melihat dan mengemudikan Kendaraan sendiri sebelum mengambil keputusan pembelian.',
    ],
  },
  warrantyTerms: {
    header: 'Pengecualian Garansi dan Syarat & Ketentuan',
    subHeader1: 'Deskripsi Garansi',
    point:
      'Layanan Inklusif dan/atau Perbaikan Inklusif dilakukan seperti yang disebutkan dalam detail paket. Pelanggan secara sukarela memilih untuk membeli paket Layanan Inklusif/Perbaikan Inklusif, produk bernilai tambah yang ditawarkan oleh PT Wisedrive Technologies Indonesia khusus untuk penggunaan pribadi saja. Untuk memperoleh manfaat tambahan dengan pembayaran biaya tambahan, tergantung pada kebijaksanaan pelanggan. Oleh karena itu, PT Wisedrive Technologies Indonesia bermaksud menjual Paket Pemeliharaan Layanan kepada pelanggan melalui dealer mobil bekas yang sah dan secara online melalui www.wisedrive.com di India, yang tunduk pada Syarat dan Ketentuan yang disebutkan di bawah ini. Pelanggan dengan ini mengonfirmasi bahwa ia telah sepenuhnya memahami dan menerima hal tersebut. Layanan dan Perbaikan Inklusif hanya berlaku untuk spesifikasi produk asli yang dibangun di pabrik.',
    subHeader2: 'Durasi Cakupan Paket (Untuk Semua Paket):',
    durationList: [
      'Paket dimulai pada tanggal mulai garansi kendaraan yang ditentukan sesuai dengan tanggal Aktivasi paket',
      'Biaya untuk layanan dan perbaikan yang dilakukan sebelum pembelian paket tidak ditanggung atau tidak dapat dikembalikan',
      'Paket berakhir ketika batas waktu tercapai, yang berlaku untuk 6 bulan (180 hari) atau 12 bulan (365 hari), atau sampai kendaraan mencapai 10.000 kilometer (mana yang lebih dulu tercapai). Berdasarkan paket yang dipilih oleh pelanggan.',
      'Jika mobil disetujui dalam periode pendinginan, kondisi KMS & Hari periode pendinginan yang disebutkan harus diselesaikan sebelum klaim garansi dapat diajukan.',
    ],
    subHead3: 'Pengecualian',
    subtitleExclusions:
      '(Layanan berikut tidak termasuk dalam "Perbaikan Inklusif")',
    exclusionsList: [
      'Bahan bakar dan kontaminasi dalam sistem bahan bakar serta kerusakan yang ditimbulkan. Kerusakan pada cat, bodi, penutup, dan panel.',
      'Semua jenis cacat kaca dan/atau kerusakan akibat kecelakaan (misalnya kaca spion, jendela, rumah lampu depan, distorsi optik, noda, kabur, dll).',
      'Ban, berat penyeimbang roda, dan kerusakan roda.',
      'Perbaikan yang menjadi tanggung jawab pengguna kendaraan (kerusakan mesin akibat kekurangan oli, pergantian oli yang terlambat, dan partisipasi dalam acara balap).',
      'Kunci hidrostatik, banjir, dan/atau kerusakan akibat kecelakaan.',
      'Kunci hidrostatik, banjir, dan/atau kerusakan akibat kecelakaan.',
      'Lampu pijar, dll. (kecuali Lampu LED dan Xenon).',
      'Cacat terkait bau dan penumpukan debu seperti nosel sistem pencuci wiper, dll.',
      'Perbaikan atau hasil yang disebabkan oleh penggunaan aksesoris asli/non-asli.',
      'Kerusakan dan kerusakan umum yang disebabkan oleh kekuatan eksternal, tabrakan, banjir, korosi, kebakaran, pencurian, gigitan tikus, atau kerusakan lanjutan yang terjadi akibat faktor eksternal dan tidak terkait dengan cacat manufaktur tidak ditanggung dalam paket pemeliharaan prabayar Wisedrive.',
      'Semua penyesuaian seperti Penyelarasan Roda, Penyeimbangan, Penyelarasan Lampu Depan, dll tidak ditanggung dalam paket pemeliharaan prabayar Wisedrive.',
      'Masalah terkait bodi dan permukaan cat tidak ditanggung dalam paket pemeliharaan prabayar Wisedrive. Bagian yang terkait dengan pemeliharaan yang dijadwalkan seperti pelumas, filter, cairan rem, cairan kemudi, sabuk penggerak, busi, pendingin, wiper, dll jika berlaku.',
      'Semua bahan habis pakai seperti Pembersih Rem, Minyak gemuk, Gas AC, aditif, Sekring, dan Relay. Sistem Knalpot lengkap seperti Pipa Silencer, Muffler, Katalitik Konverter, dan Filter Partikel Diesel.',
      'Semua baterai seperti Baterai Starter, Baterai Tambahan, dan Baterai Remote Key.',
      'Semua rakitan lampu termasuk Lampu Depan, Lampu Belakang, dan Lampu kabut.',
      'Semua bagian yang aus dan robek seperti roda, Kampas Rem dan Disc, Pelat Kopling, bagian karet terkait suspensi seperti busa, Peredam Kejut, Peredam Kejut Boot, Struts Suspensi Udara, Bellows Udara, Rel Sunroof, Panduan Sunroof, katrol, bagian Plastik dan Karet.',
      'Semua pemasangan karet seperti Pemasangan Mesin, Pemasangan Transmisi, dan Pemasangan Pipa Knalpot.',
      'Biaya untuk Diagnosa, Pemeriksaan/Pengujian, Pembaruan Perangkat Lunak, dan Adaptasi.',
      'Semua aksesoris dan bagian yang dipasang eksternal seperti sistem hiburan, dan paket tambahan.',
      'Remote multimedia, remote penguncian pusat, Dashboard, konsol tengah, sandaran tangan, jam, pelapis atap, tirai sunroof, karpet lantai, isolasi suara dan panas.',
      'Semua kerusakan lanjutan yang disebabkan oleh faktor seperti kebocoran/masuknya air ke komponen listrik dan non-listrik.',
      'Semua kegagalan yang dilaporkan akibat keterlambatan atau kelalaian dalam melakukan pemeliharaan/perbaikan yang dijadwalkan di dealer yang sah.',
      'Semua kerusakan lanjutan atau kegagalan akibat pemasangan/penggunaan suku cadang, pelumas, atau aksesoris tidak asli.',
      'Semua kegagalan lanjutan yang dilaporkan akibat penggunaan bahan bakar yang tercemar atau salah.',
      'Semua cacat yang sudah ada sebelumnya yang diamati/tercatat selama evaluasi atau dilaporkan sebelum penerbitan kebijakan sampai diperbaiki oleh dealer yang sah.',
      'Semua klaim yang dilaporkan pada kendaraan yang dinyatakan kerugian tunai/kerugian total oleh asuransi atau pihak berwenang lainnya dan kemudian diperbaiki.',
      'Semua kegagalan dan kegagalan lanjutan yang dilaporkan akibat penggunaan kendaraan secara terus-menerus meskipun sudah ada kode kesalahan atau kegagalan dalam mengidentifikasi masalah pada kendaraan.',
      'Paket Garansi Wisedrive tidak mencakup penggantian biaya untuk perbaikan/penggantian eksternal yang dilakukan oleh Anda atau untuk kerusakan akibat kecelakaan lainnya.',
    ],
    subHead4: 'Garansi ini tidak berlaku untuk:',
    warrantNotApplyList: [
      'Layanan pemeliharaan normal termasuk namun tidak terbatas pada, pembersihan & pemolesan, pembersihan injektor, dekaburisasi mesin, penyetelan mesin, penggantian oli/fluida, pengisian ulang filter, pengetatan kembali pengikat, penyesuaian pintu, rem dan kopling, penyeimbangan roda, penyelarasan roda, rotasi ban, penyelarasan lampu depan.',
      'Penggantian bagian sebagai akibat dari keausan normal, seperti busi, sabuk, kampas rem, sepatu rem, cakram rem, cakram kopling/penekan, filter, bilah wiper, bola lampu, sekring, sikat, selang, ban/tabung, baterai, sistem audio, audio video navigasi (AVN), konverter katalitik, silencer/pipa knalpot.',
      'Akhir Tie Rod, Bola Roda Kemudi, Shock Belakang, Struts Depan, Pengangkat Pintu Belakang, dan Bantalan Roda Depan & Belakang/Hub roda tidak ditanggung setelah 60.000 Km penggunaan.',
      "Bagian karet seperti kit Silinder Roda, strip/rambut cuaca pintu, & cincin 'O' A/C, kabel kopling, kabel akselerator, kabel speedometer & kabel pembuka pintu belakang.",
      'Kebocoran refrigeran A/C.',
      'Penuaan normal, kerusakan, atau karatan pada bagian berlapis, lapisan cat, bagian karet, pelapis, trim lembut, dll.',
      'Bodi, cat, kaca, trim interior/eksterior, sistem knalpot, dan keausan normal dari komponen lainnya.',
      'Kebijakan Wisedrive memiliki periode pendinginan default selama 10 hari; klaim yang terdaftar dalam periode ini tidak akan ditanggung atau disetujui.',
      'Jika model Kendaraan dilengkapi dengan Kit LPG/Kit CNG (baik yang dipasang oleh Pabrikan atau dipasang secara lokal) tidak berlaku untuk Garansi Wisedrive Extended.',
    ],
    subtitle5: 'Kerusakan atau kegagalan yang disebabkan oleh:',
    DamageFailureList: [
      'Garansi akan menjadi batal dan tidak akan dipulihkan jika mobil tidak diservis tepat waktu oleh pelanggan yang harus melakukan: 1st General Service*- Dilakukan dalam 3 bulan atau hingga 3.000 Km sejak tanggal aktivasi paket garansi (mana yang lebih dulu terjadi).',
      'Penyalahgunaan, kekerasan (seperti balapan, kelebihan beban, mengendarai di atas kopling), kecelakaan atau tabrakan, pencurian, banjir, atau kebakaran.',
      'Penggunaan bahan bakar, fluida, atau pelumas yang tidak tepat, tercemar, atau tidak mencukupi.',
      'Penggunaan suku cadang selain Suku Cadang Asli OEM.',
      'Perangkat dan/atau aksesoris yang tidak disediakan atau tidak disetujui oleh Wisedrive.',
      'Modifikasi, perubahan, pemalsuan, atau perbaikan yang tidak tepat.',
      'Suku cadang yang digunakan dalam aplikasi yang tidak dirancang atau tidak disetujui oleh Wisedrive.',
      'Perbaikan apa pun yang dilakukan selain oleh Dealer / Pusat Layanan yang Sah dari Wisedrive.',
      'Ketidakteraturan ringan yang tidak diakui mempengaruhi kualitas atau fungsi kendaraan atau bagian-bagian, seperti suara atau getaran ringan, atau barang yang dianggap sebagai karakteristik kendaraan.',
      'Hujan asam, hujan batu, badai angin, banjir, hujan asam, debu industri, atau bencana alam lainnya.',
      'Goresan cat, penyok, atau kerusakan cat atau bodi lainnya yang serupa.',
      'Revolusi atau Pemberontakan, tindakan yang disengaja atau dimodifikasi dari pemilik atau pengemudi, penyalahgunaan kendaraan, kelalaian.',
      'Tindakan elemen jalan (pasir, kerikil, debu, atau puing-puing jalan) yang mengakibatkan kerusakan cat/kaca atau kerusakan pada bagian lain.',
      'Kendaraan yang telah digunakan untuk jenis kompetisi, olahraga, reli, transportasi untuk penyewaan orang atau barang, layanan taksi atau penyewaan mobil jangka pendek atau panjang atau sekolah mengemudi, atau penggunaan komersial lainnya.',
      'Kendaraan yang dibeli sebagai taksi di bawah konsesi cukai khusus atau terdaftar sebagai taksi Wisatawan dengan Otoritas Transportasi.',
      'Kendaraan yang odometernya telah dimanipulasi, diubah, atau diputuskan.',
      'Kerusakan insidental atau konsekuensial, termasuk namun tidak terbatas pada, kehilangan waktu, ketidaknyamanan, kehilangan penggunaan kendaraan, atau kerugian komersial.',
      'Tidak ada tanggung jawab yang akan diterima untuk kerugian yang ditanggung berdasarkan kebijakan kerusakan kecelakaan atau risiko jalan atau kerusakan akibat bahaya jalan/kebakaran atau kecelakaan, tidak ada tanggung jawab dalam hal pihak ketiga.',
      'Tidak ada tanggung jawab yang akan diterima untuk kerusakan yang disebabkan oleh kelalaian, masuknya materi asing atau berbahaya, kurangnya pemeliharaan, overheat, pembekuan, atau penyalahgunaan terhadap penggunaan kendaraan yang terus-menerus setelah kerusakan menjadi jelas atau kerugian konsekuensial pada kegagalan bagian yang tidak ditanggung oleh Garansi Perpanjangan ini.',
    ],
    subHead6: 'SYARAT LAINNYA:',
    otherTermsList: [
      'Paket Service Inclusive dan/atau Repair Inclusive tersedia untuk semua mobil bekas* di seluruh rentang model (Kecuali Kendaraan Mewah) yang dijual di India.',
      'Pelanggan perlu memesan Service dan/atau Repair Inclusive melalui aplikasi Wisedrive di bagian rencana saya atau melalui dukungan pelanggan di +91 +62 87840125467.',
      'Semua pekerjaan servis dan pemeliharaan harus dilakukan di Bengkel Layanan Resmi Wisedrive atau oleh Teknisi yang Disetujui Wisedrive.',
      'Service Inclusive dan/atau Repair Inclusive dapat dipindah tangankan ke pemilik berikutnya setelah persetujuan pemeriksaan ulang, tetapi tidak dapat dipindah tangankan ke mobil lain dengan biaya.',
      'Pelanggan dapat meminta pembatalan Paket Service Inclusive dan/atau Repair Inclusive dalam waktu dua minggu sejak tanggal aktivasi paket, asalkan tidak ada layanan yang telah digunakan pada mobil di bawah cakupan apapun. Tidak ada pembatalan atau pengembalian uang yang akan dilakukan setelah periode yang disebutkan di atas.',
      'Jika kendaraan yang tercakup di bawah Service Inclusive dan/atau Repair Inclusive terlibat dalam kecelakaan yang menyebabkan kerusakan di luar perbaikan ekonomis/kerugian total, Layanan Rencana Pemeliharaan Wisedrive Service Inclusive dan/atau Wisedrive Repair Inclusive akan dibatalkan dan tidak ada penggantian uang untuk sisa periode keabsahan. Tidak ada permintaan pembatalan yang dapat diproses juga.',
      'Tidak ada pengembalian uang untuk pekerjaan servis yang telah dilakukan sebelumnya.',
      'PT Wisedrive Technologies Indonesia berhak untuk menghentikan, mengubah, menyesuaikan, menambah, atau menghapus paket, ruang lingkup layanan, pengecualian, inklusi, dll. tanpa pemberitahuan sebelumnya. Untuk Syarat dan Ketentuan terbaru, kebijakan, harga, dll, silakan kunjungi www.wisedrive.com.',
      'Konstruksi, interpretasi, dan makna ketentuan dalam Syarat dan Ketentuan ini akan ditentukan sesuai dengan hukum India. Pengadilan Bangalore akan memiliki yurisdiksi eksklusif.',
      'Pemegang garansi harus mengonfirmasi dengan PT Wisedrive Technologies Indonesia sebelum melanjutkan perbaikan kendaraan apa pun selama periode Garansi. Jika perbaikan dilakukan tanpa persetujuan dan konfirmasi sebelumnya, garansi akan menjadi tidak sah.',
      'Tidak ada dealer atau agen atau karyawannya yang berwenang untuk memperpanjang atau memperbesar garansi ini dan tidak ada dealer atau agen atau karyawannya yang berwenang untuk memberikan garansi lisan atas nama Wisedrive. Layanan garansi hanya akan diberikan oleh dealer resmi Wisedrive dan Cabang Layanan Dealer. Keputusan Wisedrive adalah final dan mengikat bagi Pemilik kendaraan dalam semua masalah garansi. Wisedrive berhak atas keputusan akhir dalam semua masalah garansi.',
      'Dealer, agen, atau personel terkait lainnya tidak memiliki wewenang atau hak untuk memfasilitasi atau melakukan perbaikan atas nama Garansi Wisedrive. Dengan tegas dinyatakan bahwa dealer, agen, atau karyawan mereka dilarang untuk mengatur atau berkomitmen melakukan perbaikan untuk kendaraan yang tercakup oleh Garansi Wisedrive.',
      'Dealer, agen, atau karyawan mereka tidak berwenang untuk mengajukan klaim garansi atas nama pelanggan. Setiap upaya untuk melakukannya akan dianggap sebagai pelanggaran terhadap syarat dan ketentuan perjanjian garansi. Kepatuhan terhadap prosedur yang benar memastikan integritas proses garansi dan memenuhi kewajiban kontraktual antara pelanggan dan Garansi Wisedrive. Setiap penyimpangan dari pedoman ini dapat mengakibatkan pelanggaran perjanjian garansi dan konsekuensi selanjutnya.',
    ],
    subHeads7:
      'Kewajiban Pelanggan: Persyaratan Sertifikat Kelayakan untuk Klaim Garansi',
    customerObligationFitnessList: [
      'Agar memenuhi syarat untuk klaim garansi, pelanggan diwajibkan memiliki sertifikat kelayakan yang sah untuk kendaraan. Persyaratan ini berlaku khusus untuk kendaraan yang berusia lebih dari 15 tahun atau sesuai dengan peraturan pemerintah yang berlaku. Kegagalan untuk menyediakan sertifikat kelayakan yang sah saat mengajukan klaim garansi akan mengakibatkan klaim ditolak.',
      'Penting untuk dipahami bahwa penyajian sertifikat kelayakan adalah syarat wajib untuk persetujuan klaim garansi. Persyaratan ini diberlakukan untuk memastikan kepatuhan terhadap standar hukum dan peraturan.',
      'Kami sangat menyarankan pelanggan untuk memastikan mereka memiliki sertifikat kelayakan yang sah untuk kendaraan mereka sebelum mencoba mengajukan klaim garansi. Kegagalan untuk memenuhi persyaratan ini dapat mengakibatkan penolakan klaim, sesuai dengan syarat dan ketentuan yang ditetapkan oleh Wisedrive.',
    ],
    subHead8:
      'Kewajiban Pelanggan: Pembaruan Kartu RC Baru untuk Garansi Wisedrive',
    customerObligationRcList: [
      'Pelanggan bertanggung jawab penuh untuk segera memperbarui Kartu Sertifikat Registrasi (RC) kendaraan yang baru dengan Wisedrive dalam waktu 45 hari sejak tanggal aktivasi Garansi Wisedrive. Kegagalan untuk memenuhi kewajiban ini dalam jangka waktu 45 hari yang ditentukan secara otomatis akan membatalkan Garansi Wisedrive dan membuatnya tidak berlaku.',
      'Dalam hal pembatalan garansi, pelanggan dapat meminta pemeriksaan ulang kendaraan oleh tim Wisedrive untuk mengaktifkan kembali paket garansi. Namun, ketersediaan slot pemeriksaan tergantung pada kebijakan dan penjadwalan tim Wisedrive. Selama periode antara pembatalan garansi dan selesainya pemeriksaan ulang, garansi tidak dapat diklaim dan dianggap batal. Kelanjutan garansi mobil tergantung pada kebijakan tim Wisedrive dan temuan mereka selama proses pemeriksaan.',
      'Penting untuk dicatat bahwa Wisedrive berhak menolak pengesahan kembali garansi berdasarkan hasil pemeriksaan.',
      'Kami menekankan pentingnya mematuhi kewajiban ini untuk memastikan validitas dan cakupan Garansi Wisedrive Anda tanpa gangguan.',
      'Untuk mengajukan klaim garansi, sangat penting bahwa nama pemilik mobil dan detail yang tertera dalam Sertifikat Registrasi Kendaraan (buku RC) sesuai dengan informasi yang tercantum dalam Kebijakan garansi. Setiap perbedaan atau ketidaksesuaian antara detail pemilik dan dokumen garansi dapat mengakibatkan penolakan klaim garansi.',
      'Pemilik mobil bertanggung jawab untuk memastikan bahwa informasi yang terkandung dalam buku RC, termasuk nama, alamat, dan rincian relevan lainnya, sesuai dengan informasi yang tercantum dalam kebijakan garansi. Setiap perubahan atau pembaruan informasi harus segera diberitahukan kepada pihak Wisedrive dan tercermin dalam buku RC serta dokumen garansi.',
      'Wisedrive berhak menolak klaim garansi jika terdapat kegagalan untuk mematuhi persyaratan ini. Disarankan agar pemilik mobil memeriksa dan memverifikasi keakuratan informasi mereka dalam buku RC dan kebijakan garansi untuk menghindari potensi komplikasi atau penolakan klaim garansi.',
    ],
    subHead9: 'Tanggung Jawab Pemilik:',
    responsibilitiesList: [
      'Penggunaan, pemeliharaan, dan perawatan kendaraan yang tepat sesuai dengan petunjuk yang terdapat dalam Buku Panduan Pemilik dan Buku Servis. Jika kendaraan digunakan dalam kondisi pemakaian yang berat, seperti beroperasi di daerah yang sangat berdebu, kasar, berkendara jarak pendek yang sering, atau menghadapi kemacetan lalu lintas yang padat di cuaca panas, pemeliharaan kendaraan harus dilakukan lebih sering seperti yang disebutkan dalam Buku Panduan Pemilik dan Buku Servis.',
      'Untuk menjaga keabsahan Garansi Ekstensi ini, kendaraan harus diservis oleh Pusat Layanan/Dealer Resmi Wisedrive sesuai dengan Buku Panduan Pemilik dan Buku Servis.',
      'Penyimpanan catatan layanan pemeliharaan. Mungkin diperlukan bagi pelanggan untuk menunjukkan bahwa pemeliharaan yang diperlukan telah dilakukan, seperti yang tercantum dalam Buku Panduan Pemilik dan Buku Servis.',
      'Pengiriman kendaraan beserta Buku Panduan Pemilik dan Buku Servis serta Sertifikat Garansi Ekstensi selama jam kerja layanan reguler ke Dealer Wisedrive yang sah untuk mendapatkan layanan garansi.',
    ],
    subHead10:
      'Kesalahan Pengemudi/Panduan yang Tidak Ditanggung dalam Klaim Garansi',
    subTitle1: 'Kegagalan untuk menjaga tingkat oli yang tepat:',
    subTitleList: [
      'Mengabaikan untuk memeriksa dan menjaga oli mesin pada tingkat yang disarankan secara teratur.',
      'Kurangnya pelumasan menyebabkan peningkatan gesekan dan keausan pada komponen mesin.',
      'Konsekuensi potensial: Kegagalan mesin, kerusakan pada bagian internal.',
    ],
    subTitle2: 'Mengabaikan interval pergantian oli:',
    subTitle2List: [
      'Mengabaikan pergantian oli tepat waktu menyebabkan degradasi oli dan pelumasan yang berkurang.',
      'Oli yang terkontaminasi menyebabkan peningkatan keausan mesin dan potensi kegagalan.',
      'Konsekuensi potensial: Kegagalan mesin, dan penurunan performa mesin.',
    ],
    subTitle3: 'Menyebabkan mesin kepanasan:',
    subTitle3List: [
      'Membiarkan mesin kepanasan akibat kerusakan sistem pendingin atau tingkat cairan pendingin yang rendah.',
      'Stres berlebihan pada mesin menyebabkan kerusakan parah.',
      'Konsekuensi potensial: Kepala silinder melengkung, gasket kepala mesin pecah, mesin macet.',
    ],
    subTitle4: 'Menggunakan bahan bakar atau oli yang salah:',
    subTitle4List: [
      'Menggunakan jenis bahan bakar yang salah (misalnya, bensin alih-alih diesel) atau oli mesin yang tidak tepat.',
      'Gangguan pada proses pembakaran mesin dan kinerja yang buruk.',
      'Konsekuensi potensial: Kerusakan mesin, dan penurunan efisiensi bahan bakar.',
    ],
    subTitle5: 'Mengabaikan tanda peringatan:',
    subTitle5List: [
      'Mengabaikan tanda peringatan mesin seperti suara tidak biasa, asap berlebihan, kehilangan daya, atau lampu peringatan di dasbor.',
      'Kegagalan untuk menangani indikasi awal masalah mesin.',
      'Konsekuensi potensial: Kerusakan lebih lanjut, kegagalan mesin, keselamatan yang terkompromikan.',
    ],
    subTitle6:
      'Mengalami putaran mesin berlebih atau melampaui batas putaran mesin (redlining):',
    subTitle6List: [
      'Memutar mesin secara berlebihan atau mengoperasikannya secara konsisten pada RPM tinggi.',
      'Memberikan tekanan berlebihan pada komponen mesin dan mempercepat keausan.',
      'Konsekuensi potensial: Peningkatan keausan mesin, dan penurunan umur mesin.',
      'Pemeliharaan yang tidak tepat dan pengabaian:',
      'Gagal melakukan tugas pemeliharaan rutin (misalnya, penggantian tali kipas, penggantian busi, penggantian filter udara).',
      'Kerusakan komponen mesin akibat pengabaian.',
      'Konsekuensi potensial: Masalah mesin, penurunan kinerja, peningkatan risiko kegagalan.',
    ],
    subNote:
      'Penting untuk dicatat bahwa daftar ini tidak lengkap, dan model kendaraan tertentu mungkin memiliki pedoman dan persyaratan tambahan yang dijelaskan dalam buku panduan pemiliknya masing-masing. Selalu merujuk pada rekomendasi produsen dan mengikuti prosedur pemeliharaan yang tepat untuk memastikan umur panjang dan kinerja kendaraan Anda.',
    noteHeader: 'Catatan Penting:',
    noteList: [
      'Garansi Perpanjangan ini dapat dipindahtangankan kepada pemilik berikutnya untuk Sisa Periode Garansi setelah persetujuan pemeriksaan ulang.',
      'Wisedrive berhak untuk membatalkan/menolak permintaan pemindahan garansi berdasarkan pemeriksaan ulang.',
      'Skema Garansi Perpanjangan ini tidak memiliki nilai tebusan, tidak ada pengembalian premi garansi yang tersedia dan tidak dapat dipindahtangankan ke kendaraan lain.',
      'Garansi Perpanjangan tidak berlaku untuk kendaraan Taksi/Fleet dan kendaraan Uji Coba.',
      'Semua layanan pemeliharaan dan perbaikan klaim garansi akan dilakukan secara eksklusif di tingkat distrik dalam negara bagian Karnataka di Pusat Layanan/Workshop Resmi yang disetujui oleh Wisedrive.',
      'Asuransi kendaraan yang valid harus diserahkan oleh pemegang garansi pada saat mengajukan/permintaan klaim garansi. Kegagalan untuk memberikan bukti asuransi akan menyebabkan penolakan klaim garansi.',
      'Permintaan klaim garansi untuk cakupan garansi di luar negara bagian Karnataka tidak akan dianggap layak atau mungkin.',
      'Semua layanan pemeliharaan untuk permintaan layanan di luar negara bagian Karnataka tidak akan dianggap layak atau mungkin.',
      'Harga Garansi Perpanjangan dapat berubah tanpa pemberitahuan terlebih dahulu.',
      'Semua pilihan Garansi Perpanjangan di atas dapat berubah atau menjadi usang tanpa pemberitahuan sebelumnya.',
      'Pemegang Garansi harus mengajukan permintaan klaim/pertanyaan melalui saluran bantuan (Email- support.id@wisedrive.com, Nomor ponsel - +62 87840125467) dalam waktu 48 jam sejak kejadian klaim, jika tidak, klaim akan dianggap tidak sah.',
      'Semua sengketa yang timbul dari Garansi Perpanjangan ini akan tunduk pada yurisdiksi Pengadilan di Bangalore saja.',
      'Wisedrive berhak untuk melakukan perbaikan atau mengubah fitur atau desain semua rencana cakupan Wisedrive kapan saja tanpa kewajiban pada kendaraan yang sudah diasuransikan. Untuk Syarat dan Ketentuan terbaru, kebijakan, dan harga, dll. silakan kunjungi www.wisedrive.com atau hubungi dukungan pelanggan Wisedrive di +62 87840125467 melalui telepon atau email kami di support.id@wisedrive.com.',
    ],
  },
  termsPage: {
    header: 'Syarat & Ketentuan',
    contentArray: [
      {
        data: (
          <>
            <strong>Kami/Kita dan Kami </strong>
            berarti PT Wisedrive Technologies Indonesia Limited
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Perjanjian </strong>berarti perjanjian antara Wisedrive dan
            Pelanggan di mana Wisedrive setuju untuk memastikan bahwa seorang
            Inspektur melakukan Inspeksi sesuai dengan syarat dan ketentuan ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Biaya Pembatalan </strong>berarti jumlah yang harus
            dibayarkan oleh Pelanggan sebagaimana disebutkan dalam syarat dan
            ketentuan ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pelanggan/Anda </strong>berarti pelanggan Wisedrive yang
            melakukan pemesanan untuk Inspeksi.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Biaya </strong>berarti jumlah yang harus dibayarkan oleh
            Pelanggan kepada Wisedrive untuk Inspeksi sebagaimana tercantum di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspeksi </strong>berarti pemeriksaan eksternal kendaraan
            secara audio-visual dan uji coba yang dilakukan oleh Inspektur atas
            nama Wisedrive untuk Pelanggan sesuai dengan syarat dan ketentuan
            ini.
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive menyediakan berbagai kategori Inspeksi, masing-masing
            dengan pemeriksaan yang berbeda. Detail kategori inspeksi dan
            pemeriksaan yang dilakukan tersedia di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            &nbsp; atau dengan menghubungi +62 87840125467. Konfirmasi kategori
            Inspeksi yang telah dipilih oleh Pelanggan untuk dilakukan pada
            Kendaraan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspektur </strong>mengacu pada inspektur yang
            berkualifikasi yang melakukan Inspeksi atas nama Wisedrive.
            Ketersediaan inspektur bergantung pada kondisi dan dapat didukung
            oleh agen pihak ketiga yang sesuai.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Laporan </strong>berarti laporan tertulis yang dibuat oleh
            Inspektur sebagai bagian dari Inspeksi, yang mencakup nama dan
            alamat Pelanggan, detail registrasi kendaraan yang diperiksa dan
            lokasinya, apakah kendaraan tersebut lulus atau gagal Inspeksi,
            daftar pemeriksaan yang dilakukan (tergantung pada jenis Inspeksi
            yang diminta oleh Pelanggan), serta ringkasan area yang perlu
            diperhatikan sebagaimana ditentukan oleh Inspektur untuk
            diinformasikan kepada Pelanggan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Daftar Periksa Laporan </strong>berarti daftar area yang
            akan atau telah diperiksa oleh Inspektur sebagai bagian dari
            Inspeksi Fisik, yang tersedia di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Kendaraan </strong>berarti kendaraan yang akan diperiksa
            oleh Inspektur atas permintaan Pelanggan.
          </>
        ),
      },
    ],
    subHeader: 'Umum',
    listContent: [
      'Inspeksi dilakukan berdasarkan pemeriksaan visual dan eksternal kendaraan saja serta terbatas pada bagian dan/atau item yang tercantum dalam Laporan. Inspeksi tidak melibatkan pembongkaran atau gangguan terhadap struktur, rakitan, komponen, atau mekanisme internal apa pun. Inspektur akan melakukan uji jalan terhadap Kendaraan dan membuat Laporan. Ada beberapa bagian Kendaraan yang tidak akan diperiksa. Anda harus membaca Daftar Periksa Laporan dengan cermat untuk melihat apa saja yang tidak diperiksa.',
      'Salinan Laporan akan dikirim kepada Anda melalui email ke alamat email yang Anda berikan saat memesan Inspeksi. Karena sifat internet dan perangkat lunak perlindungan virus yang digunakan oleh penyedia layanan internet Anda atau yang terinstal di komputer Anda, dalam beberapa kasus mungkin tidak memungkinkan untuk menjamin pengiriman Laporan melalui email. Jika Anda tidak menerima Laporan Anda dalam waktu 24 jam setelah Inspeksi Kendaraan Wisedrive dilakukan, Anda harus segera memberi tahu Kami agar Kami dapat mengirim ulang Laporan kepada Anda. Kami tidak bertanggung jawab kepada Anda atas kegagalan pengiriman Laporan sejauh kegagalan tersebut berada di luar kendali wajar Kami.',
      'Item yang tercantum dalam Daftar Periksa Laporan sebagai bagian/item yang akan diperiksa, tetapi tidak dapat diakses secara wajar pada Kendaraan, tidak akan diperiksa. Dalam keadaan seperti itu, Kami tidak memiliki kewajiban untuk memeriksa dan/atau melaporkan bagian/item tersebut, dan Inspektur akan menandai bagian terkait dalam Laporan sesuai dengan kondisi tersebut.',
      'Kendaraan harus dalam kondisi yang cukup bersih agar Inspektur dapat melihat dengan jelas dan melaporkan dengan akurat bagian kendaraan yang diperiksa. Jika kendaraan tidak bersih, Inspektur berhak untuk tidak memberikan komentar mengenai bagian tersebut dan akan menandai Daftar Periksa Laporan sesuai dengan kondisi tersebut. Dalam hal ini, Biaya Laporan tetap harus dibayar penuh.',
    ],

    subHeader1: 'Pengecualian',
    subTitle: 'Item yang Tidak Kami Periksa adalah:',
    listExcluded: [
      'Bagian yang memerlukan pembongkaran/pelepasan/pemisahan atau pencopotan untuk tujuan inspeksi',
      'Pemeriksaan data kendaraan',
      'Konsumsi oli dan bahan bakar',
      'Sumber kebocoran oli',
      'Material lapisan rem (selain yang dapat langsung terlihat tanpa membongkar apa pun)',
      'Kontaminasi cairan rem. Cairan rem akan mengalami penurunan kualitas seiring waktu, dan Kami menyarankan agar diganti sesuai rekomendasi pabrikan kendaraan',
      'Pengoperasian pemutar kaset, pemutar CD, sistem TV/DVD/navigasi satelit, Bluetooth, atau sistem hiburan dalam mobil lainnya',
      'Suara atau penerimaan radio serta sistem alarm',
      'Kompresi silinder, sistem listrik dan elektronik kendaraan yang memerlukan peralatan diagnostik khusus',
      'Emisi gas buang dan/atau catalytic converter. Jika dinyatakan lulus inspeksi oleh Inspektur, ini hanya mencakup kondisi eksternal, ketahanan terhadap kebocoran gas, dan keamanan. Inspektur tidak dapat mengonfirmasi kondisi internal atau efektivitasnya karena hal ini memerlukan pengujian emisi gas buang yang tidak termasuk dalam Inspeksi',
      'Akurasi sistem komputer dalam kendaraan (misalnya, namun tidak terbatas pada, komputer yang digunakan untuk navigasi, efisiensi bahan bakar, atau lainnya)',
      'Emisi gas buang',
      'Fungsi dan efisiensi sistem pendingin udara',
      'Area hunian pada Motorhome - Sistem listrik dan peralatan, perlengkapan air dan peralatan, serta perlengkapan gas dan peralatan tidak diperiksa. Hal ini berada di luar cakupan Inspeksi. Kami sangat menyarankan agar bagian-bagian ini diuji dan diperiksa oleh orang yang memiliki kualifikasi yang sesuai sebelum pembelian',
      'Sistem Teknis Kendaraan - Banyak kendaraan dilengkapi dengan sistem operasi otomatis atau terkomputerisasi yang dikendalikan oleh mikroprosesor. Ini termasuk sistem manajemen mesin, sistem bahan bakar, sistem pengapian, sistem pendingin udara, sistem lambda-control, radio stereo, kaset, amplifier, CD (single dan multi), TV/DVD, navigasi satelit, suspensi aktif dan self-leveling, gearbox, turbocharger dan supercharger, sistem pengereman anti-lock, sistem penggerak empat roda dan unit diferensial elektronik yang dapat dikunci, kontrol traksi, sistem alarm dan immobilizer, sistem pembuangan katalitik, serta sistem variabel camshaft timing.',
      'Dalam cakupan Inspeksi, tidak memungkinkan untuk sepenuhnya memeriksa operasi terperinci dari sistem-sistem ini karena banyaknya variasi fitur dan mode pengoperasian, serta tidak mungkin untuk mengonfirmasi bahwa sistem-sistem ini berfungsi sepenuhnya sesuai dengan spesifikasi desain pabrikan. Oleh karena itu, Inspektur hanya dapat memberikan gambaran umum dan opini terhadap kinerja secara keseluruhan dari sistem yang diperiksa. Dengan demikian, Kami tidak dapat bertanggung jawab kepada Anda atas kegagalan dalam mengidentifikasi kerusakan atau kegagalan sistem-sistem ini untuk berfungsi sesuai dengan spesifikasi yang dirancang oleh pabrikan.',
      'Aksesori non-standar sebagai akibat dari modifikasi pribadi atau lainnya',
    ],
    subheader2: (
      <p>
        Selain itu, <strong>Inspeksi tidak dapat: </strong>
      </p>
    ),
    inspectionCannotListItems: [
      'a) memastikan apakah kompartemen penumpang atau bagasi (termasuk area bodi atau karavan dari Motorhome) kedap air atau tidak',
      'b) memprediksi masa pakai sistem knalpot, kopling, atau flywheel dual-mass',
      'c) memberikan indikasi adanya kerusakan yang mungkin terlihat jika Kendaraan dikendarai melebihi kecepatan atau jarak tempuh selama uji jalan yang dilakukan oleh Inspektur',
      'd) memastikan bahwa semua atau sebagian komponen Kendaraan adalah komponen asli, atau komponen pengganti yang diproduksi oleh pabrikan kendaraan',
      'e) mencakup inspeksi terhadap bagian, komponen, atau area Kendaraan yang tidak dapat dilihat atau diakses secara wajar oleh Inspektur pada saat Inspeksi',
      'f) memastikan keaslian Dokumen Registrasi Kendaraan, jarak tempuh, Pajak Kendaraan, Nomor Identifikasi Kendaraan (VIN), Nomor Mesin, Nomor Registrasi, atau riwayat servis Kendaraan',
      'g) memeriksa adanya pemberitahuan penarikan kembali (recall). Wisedrive menyarankan Anda untuk memeriksa dengan RTO atau pabrikan apakah Kendaraan tersebut telah dikenakan pemberitahuan semacam itu.',
    ],

    listContent1: [
      <>
        <strong>Inspeksi hanya dapat </strong>mendeskripsikan dan/atau
        mengidentifikasi cacat yang benar-benar ditemukan dan/atau yang secara
        wajar dapat ditemukan melalui pemeriksaan visual eksternal terhadap
        Kendaraan pada saat Inspeksi. Kami tidak dapat bertanggung jawab atas
        cacat tersembunyi yang ditemukan kemudian, kecuali jika secara wajar
        Kami seharusnya dapat melihatnya selama Inspeksi yang dilakukan sesuai
        dengan syarat dan ketentuan ini. Kami tidak dapat memberi tahu adanya
        cacat jika kami tidak dapat melihatnya, atau jika cacat tersebut tidak
        tampak selama Inspeksi terhadap Kendaraan. Secara khusus, harap
        diperhatikan bahwa (tanpa membatasi hal tersebut) Kendaraan yang berusia
        lebih dari 5 tahun, memiliki jarak tempuh tinggi, dan/atau telah
        digunakan secara tidak normal mungkin memiliki cacat tersembunyi.
        Meskipun cacat tersebut dalam beberapa kondisi tertentu dapat menjadi
        dasar klaim terhadap penjual Kendaraan, namun hal tersebut berada di
        luar cakupan Inspeksi dan Laporan disediakan berdasarkan ketentuan ini.
        Wisedrive maupun Inspektur tidak akan bertanggung jawab kepada Anda
        akibat adanya cacat tersebut.
      </>,
      <>
        <strong>Harap diperhatikan </strong>bahwa kendaraan bekas mungkin
        memiliki cacat internal, struktural, atau mekanis yang serius dan/atau
        korosi tersembunyi, yang tidak dapat dideteksi hanya melalui pemeriksaan
        visual eksternal. Kendaraan semacam itu mungkin kurang dapat diandalkan
        dan mungkin memerlukan perbaikan/servis lebih sering dibandingkan
        kendaraan yang lebih baru. Meskipun Inspektur Kami berusaha
        mengidentifikasi potensi masalah dengan Kendaraan melalui pemeriksaan
        visual eksternal, Anda menerima risiko dan konsekuensi memiliki
        kendaraan bekas dan setuju bahwa Wisedrive maupun Inspektur tidak akan
        bertanggung jawab atas adanya cacat tersebut.
      </>,
      'Jika tidak ada bukti dokumentasi penggantian timing belt (cam belt) mesin baru-baru ini, Kami menyarankan agar sabuk Kendaraan diperiksa atau diganti sebelum pembelian.',
      'Jika Kendaraan tidak memiliki riwayat servis terbaru atau riwayat tersebut tidak tersedia bagi Inspektur pada saat Inspeksi, maka Kami menyarankan agar servis dilakukan sesuai spesifikasi pabrikan Kendaraan sebelum pembelian. Hal ini dapat mengungkapkan cacat lain yang tidak tampak dalam pemeriksaan visual eksternal oleh Inspektur.',
      <>
        <strong>Harap diperhatikan </strong>bahwa masa pakai sistem knalpot atau
        kopling tidak pasti dan sulit diprediksi. Fakta bahwa item tersebut
        tidak teridentifikasi sebagai rusak dalam Laporan tidak berarti atau
        tidak boleh diartikan bahwa sistem tersebut akan tetap berfungsi dalam
        jangka waktu tertentu setelah pemeriksaan Kami.
      </>,
    ],

    subHeader3: (
      <>
        <strong>Uji Jalan </strong>
      </>
    ),
    listContent2: [
      <>
        Agar Inspektur Kami dapat melakukan Uji Jalan terhadap Kendaraan, Anda
        harus memastikan bahwa kendaraan memiliki cukup:
        <br /> (a) Air; <br /> (b) Oli;
        <br /> (c ) Bensin.
      </>,
      'Uji jalan dilakukan di area sekitar lokasi Inspeksi. Jika:',
      'Kendaraan dalam kondisi tidak layak jalan atau tidak memiliki cukup oli, air, dan/atau bensin',
      'Pelanggan tidak dapat memastikan bahwa Kendaraan memiliki sertifikat kelayakan yang sah sehingga uji jalan tidak dapat dilakukan pada saat Inspeksi',
      'Biaya Inspeksi tetap harus dibayar penuh, dan Biaya tambahan akan dikenakan untuk setiap uji jalan tambahan yang Anda minta Kami lakukan.',
      'Pelaksanaan uji jalan tidak berarti bahwa Inspektur Kami telah melihat sertifikat kelayakan yang valid. Mendapatkan izin yang diperlukan, akses ke Kendaraan, dll.',
      'Menjadi tanggung jawab Pelanggan untuk memastikan bahwa semua persiapan yang diperlukan telah dilakukan (termasuk mendapatkan izin yang diperlukan dari pemilik Kendaraan) agar Inspeksi dapat dilakukan di bengkel atau lokasi off-road dengan area datar, keras, dan kering. Inspektur Kami memerlukan cukup ruang untuk dapat berjalan mengelilingi Kendaraan dan membuka semua pintu sepenuhnya. Juga harus tersedia cukup ruang bagi Inspektur Kami untuk memarkir kendaraannya sendiri di dekat lokasi Inspeksi.',
      'Pencahayaan dalam ruangan yang baik atau cahaya alami (jika Kendaraan diperiksa di luar ruangan) harus tersedia di lokasi Inspeksi. Kami tidak dapat memeriksa Kendaraan dalam kondisi pencahayaan yang buruk atau gelap.',
    ],

    subHeader4: 'Biaya dan Pembatalan',
    listContent3: [
      'Biaya harus dibayarkan pada saat pemesanan Inspeksi.',
      <>
        Kami berhak menolak untuk melakukan Inspeksi atau mengeluarkan Laporan
        untuk kendaraan yang: Inspektur tidak dapat mengakses secara wajar; atau
        tampaknya bagi Inspektur:
        <br /> (a) bukan kendaraan produksi standar (misalnya, tetapi tidak
        terbatas pada, mobil rakitan sendiri);
        <br /> (b) telah dimodifikasi atau tidak digunakan secara teratur
        (misalnya, menunjukkan tanda-tanda korosi berlebihan pada bagian yang
        bergerak karena lama tidak digunakan dan dapat menyebabkan Kendaraan
        tidak aman untuk dikendarai tanpa perbaikan);
        <br /> (c) tidak layak jalan atau tidak aman untuk dikendarai.
      </>,
      'Dalam keadaan yang disebutkan dalam syarat dan ketentuan ini.',
      'Jika Pelanggan gagal memastikan bahwa persiapan yang tepat telah dilakukan agar Inspeksi dapat dilaksanakan sebagaimana diwajibkan.',
      'Jika Pelanggan memberikan informasi yang salah atau tidak lengkap yang menghalangi Kami melakukan Inspeksi, dan Anda memahami bahwa dalam keadaan seperti itu Kami berhak menganggap Perjanjian berakhir dan menahan Biaya secara penuh. Jika Anda ingin Kami melakukan Inspeksi ulang, Anda harus membayar Biaya tambahan saat pemesanan.',
      'Anda berhak membatalkan Inspeksi dan menerima pengembalian dana penuh jika pembatalan dilakukan 24 jam sebelum jadwal Inspeksi. Setelah Inspeksi dilakukan, tidak ada pengembalian dana yang akan diberikan.',
      'Untuk membatalkan Inspeksi, Anda harus memberi tahu Tim Dukungan Layanan Kami tentang keputusan Anda dengan mengirim email ke support.id@wisedrive.com atau menghubungi +62 87840125467, Senin hingga Jumat pukul 9 pagi hingga 5 sore. Untuk membantu Kami menemukan pesanan Anda, Anda harus memberikan nama, alamat, nomor telepon, dan referensi pemesanan Anda (seperti yang diberikan dalam konfirmasi pemesanan Anda) bersama dengan permintaan pembatalan Anda.',
    ],
    subHeader5: 'Keluhan',
    listContent4: [
      'Jika Anda memiliki keluhan atau tidak puas dengan Inspeksi yang telah dilakukan, silakan hubungi Kami di +62 87840125467 sesegera mungkin. Kami mungkin perlu melakukan inspeksi ulang terhadap Kendaraan untuk menangani keluhan tersebut, dan Anda setuju untuk mengizinkan Kami melakukannya.',
      'Tidak boleh ada perbaikan yang dilakukan atau penggantian suku cadang pada Kendaraan yang menjadi subjek keluhan sebelum Kendaraan telah diperiksa ulang oleh Kami. Jika perbaikan darurat diperlukan untuk membuat Kendaraan aman dan kemudian menjadi subjek keluhan kepada Kami, maka Anda harus memastikan bahwa keluhan diajukan kepada Kami (termasuk pemberitahuan tentang perlunya melakukan perbaikan darurat) dalam waktu yang wajar setelah menemukan masalah tersebut, serta memastikan bahwa suku cadang yang rusak atau aus yang telah diperbaiki atau diganti disimpan untuk pemeriksaan ulang oleh Kami di masa mendatang. Kami tidak akan bertanggung jawab, dalam keadaan apa pun, atas biaya perbaikan atau penggantian suku cadang yang dilakukan tanpa persetujuan tertulis dari Kami sebelumnya.',
      'Kami berhak meminta Inspektur lain dari tim Kami untuk melakukan inspeksi ulang terhadap Kendaraan atas biaya Kami sendiri jika Kami menganggap hal itu perlu untuk menangani keluhan tersebut, dan Anda diwajibkan untuk mengizinkan Inspektur Kami melakukannya sesuai dengan syarat dan ketentuan ini. Kami akan memberikan pendapat kedua yang tidak bias terhadap Laporan awal yang telah diterbitkan.',
    ],

    subHeader6: 'Hal di luar kendali Kami yang wajar',
    listContent5: [
      'Kami tidak akan bertanggung jawab atas keterlambatan atau kegagalan dalam melakukan Inspeksi akibat peristiwa atau keadaan di luar kendali Kami yang wajar. Kami akan berusaha untuk meminimalkan dampak dari keadaan tersebut sejauh mungkin.',
      'Wisedrive hanya akan bertanggung jawab kepada Pelanggan (dan bukan kepada pihak lain) sejauh Wisedrive gagal melakukan Inspeksi sesuai dengan syarat dan ketentuan ini. Tanpa membatasi hal tersebut, Anda mengakui bahwa baik Wisedrive maupun Inspektur tidak akan bertanggung jawab kepada Anda atau pihak lain atas tanggung jawab, kerugian, kerusakan, klaim, tuntutan, biaya, atau pengeluaran (secara bersama-sama disebut sebagai “Kerugian”) yang dialami atau diderita dalam situasi berikut:',
      'Kerugian tersebut bukan akibat yang dapat diperkirakan secara wajar dari pelanggaran tersebut (Kerugian dapat diperkirakan jika dapat dipertimbangkan oleh Anda dan Kami pada saat Kendaraan diperiksa).',
      'Kerugian tersebut tidak secara langsung disebabkan oleh pelanggaran yang dilakukan oleh Kami atau Inspektur terhadap syarat dan ketentuan ini.',
      'Kerugian tersebut merupakan kerugian bisnis atau kerugian lain yang dialami oleh pelanggan yang bukan konsumen.',
      'Kerugian tersebut meningkat akibat pelanggaran yang dilakukan oleh Anda terhadap salah satu syarat dan ketentuan ini.',
      'Tidak ada dalam ketentuan ini yang akan mempengaruhi hak-hak hukum seorang konsumen berdasarkan undang-undang yang berlaku.',
    ],

    subHeader7: 'Penegakan syarat dan ketentuan',
    listContent6: [
      'Setiap klausul dalam syarat dan ketentuan ini berlaku secara terpisah. Jika ada pengadilan dengan kewenangan yang relevan memutuskan bahwa salah satu klausul ini tidak sah, klausul lainnya akan tetap berlaku sepenuhnya.',
      'Perjanjian ini berlaku antara Anda dan Wisedrive. Tidak ada pihak lain yang memiliki hak untuk menegakkan salah satu ketentuannya. Baik Anda maupun Kami tidak perlu mendapatkan persetujuan dari pihak lain untuk membuat perubahan pada syarat dan ketentuan ini.',
    ],

    subHeader8: 'Saran mengenai Laporan',
    listContent7: [
      'Kami sangat menyarankan Anda untuk mendiskusikan temuan yang terdapat dalam Laporan dengan penjual sebelum membuat keputusan untuk membeli Kendaraan. Jika Anda belum melihat Kendaraan secara langsung, Anda harus memastikan bahwa tampilan kosmetik dan spesifikasinya sesuai dengan kebutuhan dan harapan Anda. Kami menyarankan Anda untuk melihat dan mengemudikan Kendaraan sendiri sebelum mengambil keputusan pembelian.',
    ],
  },
  aiComponent: {
    header:
      'Meningkatkan Kepercayaan dan Transparansi dalam Inspeksi Mobil Bekas dengan AI/ML',
    description:
      'Wisedrive menggunakan algoritma canggih untuk mendeteksi, mengklasifikasi, dan menginterpretasikan pola kebisingan mesin. Teknologi ini membantu mengidentifikasi masalah seperti misfire, getaran tidak teratur, atau keausan, sehingga memungkinkan perawatan proaktif. Ini memastikan peningkatan kinerja mesin, keandalan, dan efisiensi operasional.',
    cardData: [
      {
        header: '20x',
        subtitle: 'Analisis Mesin yang Lebih Akurat',
        description:
          'AI kami yang dilatih dengan lebih dari satu juta suara mesin memiliki analisis mesin yang lebih akurat dan mendeteksi masalah terkait.',
      },
      {
        header: '95%',
        subtitle: 'Meminimalkan Kesalahan Manusia',
        description:
          'Inspeksi kami mengurangi campur tangan manusia dan meningkatkan kualitas laporan dengan menggunakan AI dan ML.',
      },
      {
        header: '75%',
        subtitle: 'Waktu Inspeksi Lebih Singkat',
        description:
          'Teknologi kami memastikan pengurangan waktu inspeksi hingga 75% dan laporan inspeksi dapat diselesaikan dalam waktu kurang dari 30 menit.',
      },
      {
        header: '100%',
        subtitle: 'Jaminan Kualitas Inspeksi',
        description:
          'AI kami menjamin kualitas inspeksi 100% dengan analisis suara canggih dan analisis mesin menggunakan pemindai OBD2.',
      },
    ],
  },
  cancellationAndRefund: {
    header: 'KEBIJAKAN PEMBATALAN DAN PENGEMBALIAN DANA',
    dataArray: [
      {
        subHeader: '1. SELAMA PERIODE 10 HARI AWAL',
        description:
          'Setiap pemegang polis garansi / Dealer yang telah membeli polis garansi tambahan dari PT Wisedrive Technologies Indonesia. dapat mengajukan pembatalan polis dan pengembalian dana penuh sebelum atau pada hari ke-10 (sepuluh) kalender sejak tanggal penerimaan pembayaran premi polis garansi. Pemegang Garansi / Dealer harus mengajukan permohonan pembatalan dan pengembalian dana dengan cara mengirimkan email ke PT Wisedrive Technologies Indonesia. di support.id@wisedrive.com ("Permohonan Pembatalan"). Setelah menerima Permohonan Pembatalan dalam periode yang disebutkan di atas, PT Wisedrive Technologies Indonesia. akan membatalkan polis garansi dan seluruh jumlah yang telah dibayarkan oleh Pemegang Polis Garansi / Dealer akan dikembalikan. Dengan ini ditegaskan bahwa Garansi dan seluruh hak berdasarkan Polis Garansi akan berakhir dan tidak berlaku segera setelah tanggal Permohonan Pembatalan. Tidak ada klaim yang akan diterima oleh PT Wisedrive Technologies Indonesia. dari Pemegang Polis Garansi / Dealer setelah tanggal Permohonan Pembatalan.',
      },
      {
        subHeader: '2. PERMOHONAN PEMBATALAN DITERIMA SETELAH 10 HARI AWAL',
        description:
          'Pemegang Polis Garansi berhak menerima pengembalian dana jika pembatalan polis dilakukan dalam waktu 10 hari sejak penerimaan premi. Pemegang Polis Garansi tetap memiliki hak untuk mengajukan permohonan pembatalan setelah periode tersebut, namun untuk setiap Permohonan Pembatalan yang diterima setelah jangka waktu tersebut, tidak ada pengembalian dana yang akan diproses oleh PT Wisedrive Technologies Indonesia..',
      },
      {
        subHeader: '3. PEMBAYARAN DAN METODE PENGEMBALIAN DANA',
        description:
          'Untuk Permohonan Pembatalan yang diajukan dalam waktu 10 hari sejak pembayaran, pengembalian dana akan dilakukan dalam waktu 14 (empat belas) hari kerja sejak tanggal penerimaan Permohonan Pembatalan. Pengembalian dana akan diproses melalui metode pembayaran asli, yaitu ke metode pembayaran yang digunakan awalnya oleh Pemegang Polis Garansi atau PT Wisedrive Technologies Indonesia. dapat, atas kebijakannya sendiri, memproses pengembalian dana melalui metode lain setelah menerima instruksi khusus dari Pemegang Polis Garansi beserta rincian yang diperlukan dalam Permohonan Pembatalan yang bersangkutan.',
      },
    ],
  },
  privacyData: {
    header: 'Kebijakan Privasi PT Wisedrive Technologies Indonesia',
    contentArray: [
      {
        subHeader: 'Apa yang kami lakukan dengan informasi Anda?',
        subContent:
          'Saat Anda membeli sesuatu dari toko kami, sebagai bagian dari proses pembelian dan penjualan, kami mengumpulkan informasi pribadi yang Anda berikan kepada kami seperti nama, alamat, dan alamat email Anda. Saat Anda menjelajahi toko kami, kami juga secara otomatis menerima alamat protokol internet (IP) komputer Anda untuk memberikan informasi yang membantu kami memahami browser dan sistem operasi Anda. Pemasaran melalui email (jika berlaku): Dengan izin Anda, kami dapat mengirimkan email tentang toko kami, produk baru, dan pembaruan lainnya.',
      },
      {
        subHeader: 'Persetujuan',
        subContent:
          'Bagaimana Anda memberikan persetujuan saya? Saat Anda memberikan informasi pribadi kepada kami untuk menyelesaikan transaksi, memverifikasi kartu kredit Anda, melakukan pemesanan, mengatur pengiriman, atau mengembalikan pembelian, kami menganggap bahwa Anda memberikan persetujuan Anda untuk kami mengumpulkannya dan menggunakannya hanya untuk alasan tertentu tersebut. Jika kami meminta informasi pribadi Anda untuk alasan sekunder, seperti pemasaran, kami akan meminta izin Anda secara langsung atau memberikan kesempatan bagi Anda untuk menolaknya. Bagaimana saya dapat menarik persetujuan saya? Jika setelah Anda menyetujui, Anda berubah pikiran, Anda dapat menarik persetujuan Anda bagi kami untuk menghubungi Anda, untuk terus mengumpulkan, menggunakan, atau mengungkapkan informasi Anda kapan saja dengan menghubungi kami di support.id@wisedrive.com.',
      },
      {
        subHeader: 'Pengungkapan',
        subContent:
          'Kami dapat mengungkapkan informasi pribadi Anda jika kami diwajibkan oleh hukum atau jika Anda melanggar Ketentuan Layanan kami.',
      },
      {
        subHeader: 'Pembayaran',
        subContent:
          'Kami menggunakan Razorpay untuk memproses pembayaran. Kami/Razorpay tidak menyimpan data kartu Anda di server mereka. Data dienkripsi melalui Standar Keamanan Data Industri Kartu Pembayaran (PCI-DSS) saat memproses pembayaran. Data transaksi pembelian Anda hanya digunakan selama diperlukan untuk menyelesaikan transaksi pembelian Anda. Setelah itu, informasi transaksi pembelian Anda tidak disimpan. Gateway pembayaran kami mematuhi standar yang ditetapkan oleh PCI-DSS yang dikelola oleh Dewan Standar Keamanan PCI, yang merupakan upaya bersama dari merek seperti Visa, MasterCard, American Express, dan Discover. Persyaratan PCI-DSS membantu memastikan penanganan informasi kartu kredit secara aman oleh toko kami dan penyedia layanannya. Untuk wawasan lebih lanjut, Anda juga dapat membaca syarat dan ketentuan Razorpay.',
      },
      {
        subHeader: 'Layanan pihak ketiga',
        subContent:
          'Secara umum, penyedia pihak ketiga yang kami gunakan hanya akan mengumpulkan, menggunakan, dan mengungkapkan informasi Anda sejauh yang diperlukan untuk memungkinkan mereka menjalankan layanan yang mereka berikan kepada kami. Namun, penyedia layanan pihak ketiga tertentu, seperti gateway pembayaran dan pemroses transaksi pembayaran lainnya, memiliki kebijakan privasi mereka sendiri terkait informasi yang kami wajib berikan kepada mereka untuk transaksi pembelian Anda. Untuk penyedia ini, kami menyarankan Anda membaca kebijakan privasi mereka agar Anda memahami bagaimana informasi pribadi Anda akan ditangani oleh penyedia ini. Khususnya, ingatlah bahwa penyedia tertentu mungkin berlokasi atau memiliki fasilitas yang berada di yurisdiksi yang berbeda dari Anda atau kami. Jadi, jika Anda memilih untuk melanjutkan transaksi yang melibatkan layanan penyedia pihak ketiga, maka informasi Anda mungkin tunduk pada hukum yurisdiksi tempat penyedia layanan tersebut atau fasilitasnya berada. Setelah Anda meninggalkan situs toko kami atau dialihkan ke situs web atau aplikasi pihak ketiga, Anda tidak lagi tunduk pada Kebijakan Privasi ini atau Ketentuan Layanan situs web kami. Tautan Saat Anda mengklik tautan di toko kami, tautan tersebut dapat mengarahkan Anda keluar dari situs kami. Kami tidak bertanggung jawab atas praktik privasi situs lain dan mendorong Anda untuk membaca pernyataan privasi mereka.',
      },
      {
        subHeader: 'Keamanan',
        subContent:
          'Untuk melindungi informasi pribadi Anda, kami mengambil tindakan pencegahan yang wajar dan mengikuti praktik terbaik industri untuk memastikan informasi tersebut tidak hilang, disalahgunakan, diakses, diungkapkan, diubah, atau dihancurkan secara tidak semestinya.',
      },
      {
        subHeader: 'Cookies',
        subContent:
          'Kami menggunakan cookies untuk menjaga sesi pengguna Anda. Cookies ini tidak digunakan untuk mengidentifikasi Anda secara pribadi di situs web lain.',
      },
      {
        subHeader: 'Usia persetujuan',
        subContent:
          'Dengan menggunakan situs ini, Anda menyatakan bahwa Anda setidaknya telah mencapai usia dewasa di negara bagian atau provinsi tempat tinggal Anda, atau bahwa Anda telah mencapai usia dewasa di negara bagian atau provinsi tempat tinggal Anda dan telah memberikan izin kepada kami untuk memungkinkan anak di bawah umur yang menjadi tanggungan Anda menggunakan situs ini.',
      },
      {
        subHeader: 'Perubahan kebijakan privasi ini',
        subContent:
          'Kami berhak untuk mengubah kebijakan privasi ini kapan saja, jadi harap tinjau secara berkala. Perubahan dan klarifikasi akan berlaku segera setelah diposting di situs web. Jika kami membuat perubahan material terhadap kebijakan ini, kami akan memberi tahu Anda di sini bahwa kebijakan ini telah diperbarui, sehingga Anda mengetahui informasi apa yang kami kumpulkan, bagaimana kami menggunakannya, dan dalam keadaan apa, jika ada, kami menggunakan dan/atau mengungkapkannya. Jika toko kami diakuisisi atau bergabung dengan perusahaan lain, informasi Anda mungkin akan dialihkan ke pemilik baru sehingga kami dapat terus menjual produk kepada Anda.',
      },
      {
        subHeader: 'Pertanyaan & informasi kontak',
        subContent:
          'Jika Anda ingin: mengakses, mengoreksi, mengubah, atau menghapus informasi pribadi yang kami miliki tentang Anda, mengajukan keluhan, atau sekadar ingin informasi lebih lanjut, hubungi Petugas Kepatuhan Privasi kami di support.id@wisedrive.com.',
      },
    ],
  },
};
